/**
 * Legacy entity classes — combined from MyScripts/Entities/*.ts
 * Auto-generated by combine-entities.js
 */

// External globals used by entity code
import { App } from '@/services/app-compat';
import { api } from '@/services/api-class';
import { Codes } from '@/constants/codes';
import moment from 'moment';
import { hasValue, hasStringValue, currentUserHasPermission, getOfficerLabel } from '@/utils/legacy-utils';
import { ModuleType } from '@/constants/codes';
// Lazy wrappers: these window globals may not be assigned yet at module load
// time (they are set by other modules in the same bundle or by MyBuiltScripts.js
// which loads after ReactBundle.js). Wrapping them defers resolution to call time.
const _wg = (name: string) => (...args: any[]) => (window as any)[name](...args);
const Guid = { newGuid: () => (window as any).Guid.newGuid() };
import { hasNumericValue } from '@/utils/validation';
const deepCopyProperties = _wg('deepCopyProperties');
import { getAuthObject, getCurrentUserId } from '@/utils/auth';
const getInsecureUUID = _wg('getInsecureUUID');
const getNullableDateClone = _wg('getNullableDateClone');
const isDateObject = _wg('isDateObject');
const arraysEqual = _wg('arraysEqual');
const arraysEqualsWithIEquals = _wg('arraysEqualsWithIEquals');
const sortAndRemoveDuplicates = _wg('sortAndRemoveDuplicates');
const getObjectInArrayByProperty = _wg('getObjectInArrayByProperty');
const isBetaTesting = _wg('isBetaTesting');
const goToInProgressScreen = _wg('goToInProgressScreen');
const getCustomLocationListPromise = _wg('getCustomLocationListPromise');
const getPatrolZoneNames = _wg('getPatrolZoneNames');
import { validateAddressWithSuggestions } from '@/utils/custom-location';
const fillInAddressFromSuggestions = _wg('fillInAddressFromSuggestions');
const mergeCurrentNatureOfCallIntoNatureOfCallList = _wg('mergeCurrentNatureOfCallIntoNatureOfCallList');
const mergeCurrentCallDispositionIntoCallDispositionList = _wg('mergeCurrentCallDispositionIntoCallDispositionList');
const processCallCardAvailableOfficers = _wg('processCallCardAvailableOfficers');
const updateInProgressScreenFromEvent = _wg('updateInProgressScreenFromEvent');
const isMapScreenLoaded = _wg('isMapScreenLoaded');
const updateMapFromEvent = _wg('updateMapFromEvent');
const isCallCardRealtimeEnabled = _wg('isCallCardRealtimeEnabled');
const setCallCardRealtimeEnabled = _wg('setCallCardRealtimeEnabled');
const isCallCardScreenLoaded = _wg('isCallCardScreenLoaded');
const setCallCardScreenLoaded = _wg('setCallCardScreenLoaded');
// These are registered on window by notification-dialogs.ts
const setShowingRecentOfficerAssignedDialogOnPageLoaded = _wg('setShowingRecentOfficerAssignedDialogOnPageLoaded');
const isShowingRecentOfficerAssignedDialogOnPageLoaded = _wg('isShowingRecentOfficerAssignedDialogOnPageLoaded');
const showRecentOfficerAssignedDialogIfNotVisibleWithoutSound = _wg('showRecentOfficerAssignedDialogIfNotVisibleWithoutSound');
const addMDTActiveCallCard = _wg('addMDTActiveCallCard');
const removeMDTActiveCallCard = _wg('removeMDTActiveCallCard');
const getMDTActiveCallCardId = _wg('getMDTActiveCallCardId');
const updateMDTEditModeAllowed = _wg('updateMDTEditModeAllowed');
const refreshPage = _wg('refreshPage');
// Note: stopPanicSounds is defined later in this file
const reloadPageSkipBrowserCache = _wg('reloadPageSkipBrowserCache');
const showHomePage = _wg('showHomePage');
const WeekDays = (window as any).WeekDays;
const WeekDay = (window as any).WeekDay;
const OfficerCommentsRequired = (window as any).OfficerCommentsRequired;
const OfficerAttachmentsEnabled = (window as any).OfficerAttachmentsEnabled;
const EnabledTourStopDaysType = (window as any).EnabledTourStopDaysType;
// Note: TourExemption is defined later in this file
const DATETIME_FORMAT_DISPLAY_LOCAL_MOMENT = (window as any).DATETIME_FORMAT_DISPLAY_LOCAL_MOMENT;
const DATETIME_FORMAT_SERVER_UTC = (window as any).DATETIME_FORMAT_SERVER_UTC;
import { load } from '@/services/loading';
const setNPSDItemLocked = _wg('setNPSDItemLocked');
let callCardClockRefreshInterval = (window as any).callCardClockRefreshInterval;

// ============================================================================
// entity-base.ts
// ============================================================================

export abstract class EntityBase {
    protected deserialize(instanceData: any) {
        const keys = Object.keys(this);

        for (const key of keys) {
            if (instanceData.hasOwnProperty(key)) {
                this[key] = instanceData[key];
            }
        }
    }
}


// ============================================================================
// other-entities.ts
// ============================================================================

export class BackUpUnit {
    constructor(result: any) {
        if (result !== undefined && result !== null) {
            for (let k in result) {
                if (this[k] !== undefined && result[k] !== undefined) {
                    this[k] = result[k];
                }
            }
        }
    }

    id: number = null;
    officer: number = null;//, id of officer
    officerName: string = "";//- GET ONLY - string, name of officer with last name first
    dispatched: Date = null;
    enroute: Date = null;
    onScene: Date = null;
    cleared: Date = null;
}

export class RespondingAgency {
    constructor(result: any) {
        if (result !== undefined && result !== null) {
            for (let k in result) {
                if (this[k] !== undefined && result[k] !== undefined) {
                    this[k] = result[k];
                }
            }
        }
    }

    id: number = null;
    agency: string = ""; // name of agency
    people: string = ""; // people involved
    arrived: Date = null; // when agency arrived at scene
    notes: string = ""; // notes
}

export class Offender {
    constructor(result: any) {
        this.tempid = Guid.newGuid();

        if (result !== undefined && result !== null) {
            for (let k in result) {
                if (this[k] !== undefined && result[k] !== undefined) {
                    this[k] = result[k];
                }
            }
        }
    }

    id: number = null;
    npsdPerson: number = null; //, id of npsd person offender
    arrested: number = null; //, 1 for yes, 2 for no, 3 for n/ a
    offenses: Array<number> = null; // list of number = null; //.number = null; //egers map to offense string = ""; //s
    officerNotes: string = ""; //

    personName: string = "";
    tempid: string = "";
}

export class Accident {
    constructor(result: any) {
        if (result !== undefined && result !== null) {
            for (let k in result) {
                if (this[k] !== undefined && result[k] !== undefined) {
                    if (k === 'accidentPersonList') {
                        for (const ap of result[k]) {
                            this.accidentPersonList.push(new accidentPerson(ap));
                        }
                    } else {
                        this[k] = result[k];
                    }
                }
            }
        }
    }

    accidentPersonList: Array<accidentPerson> = [];

    roadwayConditions: string = ""; //
    findings: string = ""; //
    notes: string = ""; //
}

export class accidentPerson {
    constructor(result: any) {
        this.tempid = Guid.newGuid();

        if (result !== undefined && result !== null) {
            for (let k in result) {
                if (this[k] !== undefined && result[k] !== undefined) {
                    this[k] = result[k];
                }
            }
        }
    }

    npsdPerson: number = null; //, id of npsd person
    personName: string = null; // display name of person
    //roles: Array<number> = null; //.number = null; //egers map to accident person role string = ""; //s.
    npsdVehicle: number = null; //, id of npsd vehicle
    vehicleName: string = null; // display name of vehicle
    isAtFault: number = null; //, 1 for yes, 2 for no, 3 for n/ a
    isInjured: number = null; //, 1 for yes, 2 for no, 3 for n/ a
    isVehicleDamaged: number = null; //, 1 for yes, 2 for no, 3 for n/ a
    injuryNotes: string = ""; //
    id: number = null;
    tempid: string;
}

export class Property {
    constructor(result: any) {
        if (result !== undefined && result !== null) {
            for (let k in result) {
                if (this[k] !== undefined && result[k] !== undefined) {
                    this[k] = result[k];
                }
            }
        }

        this.tempid = Guid.newGuid();
    }

    id: number = null;
    item: string = ""; //
    npsdPersonOwner: number = null; //id of npsd person who owns item
    npsdBusinessOwner: number = null; //id of npsd business that owns item
    npsdClientOwner: number = null; //id of npsd client that owns item
    reportedAs: number = null; //.number = null; //eger maps to a property reported as string = ""; //
    estimatedValue: EstimatedValue = new EstimatedValue(""); //eger estimatedValue: number = null; //, in cents.For example, "$19.95" gets sent as "1995"
    damages: string = ""; //
    storageLoc: string = ""; //
    brand: string = ""; //
    model: string = ""; //
    year: string = ""; //
    colors: string = ""; //
    serialNum: string = ""; //
    location: string = ""; //
    officerNotes: string = ""; //
    tempid: string;
}

export class EstimatedValue {
    constructor(result: any) {
        if (result !== undefined && result !== null) {
            for (let k in result) {
                if (this[k] !== undefined && result[k] !== undefined) {
                    this[k] = result[k];
                }
            }
        }
    }

    code: string = null;
    value: number = null;
}

export class MedicalReport {
    constructor(result) {
        this.tempid = Guid.newGuid();

        if (result !== undefined && result !== null) {
            for (let k in result) {
                if (this[k] !== undefined && result[k] !== undefined) {
                    if (k==="lastAte") {
                        this[k] = getNullableDateClone(result[k]);
                    } else {
                        this[k] = result[k];
                    }
                }
            }
        }
    }

    public updateReport(result) {
        if (result !== undefined && result !== null) {
            for (let k in result) {
                if (this[k] !== undefined && result[k] !== undefined) {
                    if (k === "lastAte" && result[k] !== null) {
                        this[k] = result[k];// (moment(result[k]).utc().format("YYYY-MM-DDTHH:mm:ss") + ".000Z");
                    } else {
                        this[k] = result[k];
                    }
                }
            }
        }
    }

    id: number = null; //
    patient: number = null; //, id of npsd person patient
    hospitalized: number = null; //, 1 for yes, 2 for no, 3 for n/ a
    symptomsOrInjuriesTxt: string = ""; //
    officerNotesTxt: string = ""; //
    //Patient History
    heartProblems: number = null; //, Do you have a history of heart problems?
    highBloodPressure: number = null; //, Do you have a history of high blood pressure?
    hypertensionPatientHistory: number = null; //, Do you have a history of hypertension?
    diabetes: number = null; //, Do you have a history of diabetes?
    medications: number = null; //, Are you taking any prescription medication?
    medicationsTxt: string = ""; // //user types in medications
    otcMedications: number = null; //, Are you taking any OTC/ non prescribed medication
    otcMedicationsTxt: string = ""; //
    vitamins: number = null; //, Are you taking any vitamins, homeopathics, herbal medicines or supplements?
    vitaminsTxt: string = ""; //
    allergicToMedications: number = null; //, Are you allergic to any medications?
    allergicToMedicationsTxt: string = ""; //
    lastAte: any = null; //When did you last eat?
    majorSurgeries: number = null; //, Have you had any major surgeries/ illnesses
    majorSurgeriesTxt: string = ""; // //user types in list of major surgeries
    //ABDOMINAL/DIGESTIVE
    abdominalPain: number = null; //, Abdominal Pain?
    nausea: number = null; //, Nausea or vomiting?
    bloating: number = null; //, Bloating, gas or indigestion?
    heartburn: number = null; //, Heartburn ?
    ulcer: number = null; //, Ulcer ?
    difficultySwallowing: number = null; //, Difficulty swallowing?
    jaundice: number = null; //, Jaundice ?
    liverDisease: number = null; //, Liver disease?
    gallBladderProblems: number = null; //, Gallbladder problems?
    pancreatitis: number = null; //, Pancreatitis ?
    bowelHabits: number = null; //, Change in bowel habits?
    bloodyStool: number = null; //, Black or bloody stool?
    colonCancer: number = null; //, Colon Cancer or Colon Polyps?
    hemorrhoids: number = null; //, Hemorrhoids ?
    abdominalTxt: string = ""; //
    //Cardiovascular
    chestPain: number = null; //, Chest Pain or tightness?
    palpitations: number = null; //, Palpitations ?
    swollenLegs: number = null; //, Swollen legs or feet?
    hypertensionCardio: number = null; //, Hypertension ?
    hyperlipidemia: number = null; //, Hyperlipidemia ?
    angina: number = null; //, Angina ?
    rheumaticFever: number = null; //, Rheumatic Fever?
    claudication: number = null; //, Claudication or leg pain on walking?
    bloodClots: number = null; //, Blood Clots?
    varicoseVeins: number = null; //, Varicose veins?
    cardiovascularTxt: string = ""; //
    //GENITAL/URINARY
    urinaryProblems: number = null; //, Urinary problems? Yes or No
    bloodInUrine: number = null; //, Blood in urine ? Yes or No
    kidneyStones: number = null; //, Kidney Stones? Yes or No
    urinaryInfections: number = null; //, Urinary infections? Yes or No
    sexualDysfunction: number = null; //, Sexual dysfunction? Yes or No
    useContraceptives: number = null; //, Do you use a contraceptive? Yes or No
    urinaryTxt: string = ""; //

    personName: string = "";
    tempid: string = "";
}

export class Statement {
    constructor(result: any) {
        this.tempid = Guid.newGuid();

        if (result !== undefined && result !== null) {
            for (let k in result) {
                if (this[k] !== undefined && result[k] !== undefined) {
                    this[k] = result[k];
                }
            }
        }
    }

    id: number = null;
    npsdPerson: number = null; //, id of npsd person
    //roles: Array<number> = null;// list of number = null; //.number = null; //egers map to statement role string = ""; //s
    statement: string = ""; //
    personName: string = "";
    personRoles: Array<string> = null;
    tempid: string;
}

export class DigitalEvidence {
    constructor(result: any) {
        this.tempid = Guid.newGuid();

        if (result !== undefined && result !== null) {
            for (let k in result) {
                if (this[k] !== undefined && result[k] !== undefined) {
                    this[k] = result[k];
                }
            }
        }
    }

    id: number = null;
    title: string = ""; //
    evidenceOf: number = null; //.number = null; //eger maps to evidence of string = ""; //
    involving: string = ""; //
    evidenceOfName: string = "";
    involvingName: string = "";
    attachmentList: Array<Attachment> = [];
    attachmentInfoList: Array<AttachmentInfo> = [];
    tempid: string;
}

export class AttachmentInfo {
    id: number = null; //long, id of attachment in our database corresponding to an uploaded attachment
    activationKey: string = ""; //, key to activate attachment data in our database once corresponding file has been uploaded
}
export class AttachmentInfoWithGuid extends AttachmentInfo {
    guid: string = null;
    signedURL: string = null;
}

export class Attachment {
    id: number = null;
    signedURL: string = "";
    filename: string = "";
    title: string = "";
    typeName: string = null;
    createdBy: string = "";
    dateCreated: string = "";
}
export class AttachmentWithGuid extends Attachment {
    guid: string = Guid.newGuid();
}

export class Email {
    constructor(result: any) {
        if (result !== undefined && result !== null) {
            for (let k in result) {
                if (this[k] !== undefined && result[k] !== undefined) {
                    this[k] = result[k];
                }
            }
        }
    }

    id: number = null;
    email: string = null;
    emailType: string = null;
}

export class NameValue {
    id: number = null;
    name: string; //display name of time zone
    value: string; // time zone id
}

export interface ICloneable {
    clone();
}

export interface IEquals {
    equals(other);
}

export class NPSDReport {
    constructor(result: any) {
        if (result !== undefined && result !== null) {
            for (let k in result) {
                if (this[k] !== undefined && result[k] !== undefined) {
                    this[k] = result[k];
                }
            }
        }
    }

    id: number;// long, id of report
    callDate: Date;// - datetime
    natureOfCall: Array<Number> = [];// - list of integers
    roles: Array<Number> = [];//  - list of integers (corresponding to report- person roles)
    offenses: Array<Number> = [];//  - list of integers (corresponding to offender offenses)
}

export class JSErrorType {
    static CAUGHT: string = 'caught';
    static UNCAUGHT: string = 'uncaught';
}

export class KSTPositionError implements GeolocationPositionError {
    readonly PERMISSION_DENIED = 1;
    readonly POSITION_UNAVAILABLE = 2;
    readonly TIMEOUT = 3;
    readonly code: number = null;
    readonly message: string = null;

    constructor(result: any) {
        if (result !== undefined && result !== null) {
            for (let k in result) {
                if (this[k] !== undefined && result[k] !== undefined) {
                    this[k] = result[k];
                }
            }
        }
    }
}

export class GeocodedLocation {
    constructor(result: any) {
        if (result !== undefined && result !== null) {
            for (let k in result) {
                if (this[k] !== undefined && result[k] !== undefined) {
                    this[k] = result[k];
                }
            }
        }
    }

    geocoderResults: Array<any> = null;
    locationType: string = null;
    locationCoords: { lat: number, lng: number } = null;
}

// ============================================================================
// access-authorities.ts — extracted to @/models/access-authorities.ts
// ============================================================================

import { AccessAuthorities } from '@/models/access-authorities';
export { AccessAuthorities };

// ============================================================================
// phone-number.ts
// ============================================================================

export class PhoneNumber {
    phoneType: string;
    phoneNumber: string;

    constructor(args: any) {
        if (args !== undefined && args !== null) {
            for (let k in args) {
                if (this[k] !== undefined && args[k] !== undefined) {
                    this[k] = args[k];
                }
            }
        }
    }
}

// ============================================================================
// navigation-type.ts — extracted to @/models/other-entities.ts
// ============================================================================

import { OrnaNavigationType, CustomLocationOrCoordinatesType } from '@/models/other-entities';
import type { CustomLocationOrCoordinates } from '@/models/other-entities';
export { OrnaNavigationType, CustomLocationOrCoordinates, CustomLocationOrCoordinatesType };

// ============================================================================
// data-object-location-fields.ts
// ============================================================================

export interface DataObjectLocationFieldsType {
    address: {
        address?: string;
        city?: string;
        state?: string;
        zip?: string;
        country?: string;
        formattedAddress: string;
    };
    coordinates: {
        latitude: string;
        longitude: string;
    };
    customlocation: {
        customLocationId: string;
    };
    properties: {
        isOnlySavingCoordinatesOnCustomLocation: boolean,
    };
}

export class DataObjectLocationFields {
    private static callForServiceAndCaseReport: DataObjectLocationFieldsType = {
        address: {
            address: 'callLocAddress',
            city: 'callLocCity',
            state: 'callLocState',
            zip: 'callLocZip',
            country: 'callLocCountry',
            formattedAddress: 'callLocFormattedAddress',
        },
        coordinates: {
            latitude: 'latitude',
            longitude: 'longitude',
        },
        customlocation: {
            customLocationId: 'customLocationId',
        },
        properties: {
            isOnlySavingCoordinatesOnCustomLocation: false,
        }
    };

    private static npsdData: DataObjectLocationFieldsType = {
        address: {
            address: 'locAddress',
            city: 'locCity',
            state: 'locState',
            zip: 'locZip',
            country: 'locCountry',
            formattedAddress: 'locFormattedAddress',
        },
        coordinates: {
            latitude: 'latitude',
            longitude: 'longitude',
        },
        customlocation: {
            customLocationId: 'customLocationId',
        },
        properties: {
            isOnlySavingCoordinatesOnCustomLocation: true,
        }
    };

    public static tourStop: DataObjectLocationFieldsType = {
        address: {
            formattedAddress: 'location',
        },
        coordinates: {
            latitude: 'locationLatitude',
            longitude: 'locationLongitude',
        },
        customlocation: {
            customLocationId: 'customLocationId',
        },
        properties: {
            isOnlySavingCoordinatesOnCustomLocation: false,
        }
    };

    public static callAlert: DataObjectLocationFieldsType = {
        address: {
            formattedAddress: 'locFormattedAddress',
        },
        coordinates: {
            latitude: 'latitude',
            longitude: 'longitude',
        },
        customlocation: {
            customLocationId: 'customLocationId',
        },
        properties: {
            isOnlySavingCoordinatesOnCustomLocation: true,
        }
    };

    // Client sites keep a free-text `location` string and (per Client Location Trust) may carry a
    // latitude/longitude when a save-time geocode resolved with a trustworthy provenance. Coords are
    // stored (not cleared like npsdData), and only the formatted-address field is mapped so the
    // geocoder never rewrites the site's other columns — sites have no city/state/zip fields.
    public static clientSite: DataObjectLocationFieldsType = {
        address: {
            formattedAddress: 'location',
        },
        coordinates: {
            latitude: 'latitude',
            longitude: 'longitude',
        },
        customlocation: {
            customLocationId: 'customLocationId',
        },
        properties: {
            isOnlySavingCoordinatesOnCustomLocation: false,
        }
    };

    public static callForService: DataObjectLocationFieldsType = DataObjectLocationFields.callForServiceAndCaseReport;
    public static caseReport: DataObjectLocationFieldsType = DataObjectLocationFields.callForServiceAndCaseReport;

    public static business: DataObjectLocationFieldsType = DataObjectLocationFields.npsdData;
    // Clients diverge from the npsdData template on one property (Client Location Trust): geocoded
    // coordinates ARE persisted, not nulled. The record's coordinate + provenance status is what
    // lets call entry skip geocoding for known clients; person/business keep the legacy
    // custom-location-only behavior.
    public static client: DataObjectLocationFieldsType = {
        ...DataObjectLocationFields.npsdData,
        properties: {
            isOnlySavingCoordinatesOnCustomLocation: false,
        },
    };
    public static person: DataObjectLocationFieldsType = DataObjectLocationFields.npsdData;
}

// ============================================================================
// user.ts
// ============================================================================

export class NewUser {
    firstName: string = null; // new user first name
    lastName: string = null; // new user last name
    isLoginEnabled = true; // is login enabled
    email: string = null; // new user primary email
    permissionGroupIds: Array<number> = []; // list of long, each element is an id for a permission group that the new user has access to
}

// ============================================================================
// client-automated-notification.ts
// ============================================================================

export class ClientAutomatedNotification {
    id: number = null;
    notifiedName: string = null;
    notifiedEmail: string = null;
    notificationTimeZoneId: string = null;
    notificationTime: number = null;
    activityReportNotificationFrequency: string = null;

    constructor(args: any) {
        if (args !== undefined && args !== null) {
            for (let k in args) {
                if (this[k] !== undefined && args[k] !== undefined) {
                    this[k] = args[k];
                }
            }
        }
    }
}

// ============================================================================
// client-group-site.ts
// ============================================================================

export class ClientGroupSite {
    uuid?: string; //Temporary id used by grid component for tracking deleting rows. Not used by backend.
    id: number;
    siteName: string;
    location: string;

    constructor(args: any) {
        if (args !== undefined && args !== null) {
            for (let k in args) {
                if (this[k] !== undefined && args[k] !== undefined) {
                    this[k] = args[k];
                }
            }
        }
    }
}

// ============================================================================
// error.ts
// ============================================================================

export class ServerErrors {
    constructor(result: any, total: any) {
        if (result === "Internal Server Error") {
            const err = new ServerError();
            err.message = result;

            this.errors.push(err);
        }
        else {
            if (result !== undefined && result !== null) {
                for (let k in result) {
                    if (this[k] !== undefined) {
                        this[k] = result[k];
                    }
                }
            }
        }

        this.total = total;
    }
    total: number;
    errors: Array<ServerError> = [];

    displayErrors() {
        let errorBody = "";
        let errorMessages = [];
        if (this.errors.length > 0) {
            for (let error of this.errors) {
                errorMessages.push(error.message);
            }
        }
        else if (this.errors["message"] !== undefined) {
            errorMessages.push(this.errors["message"]);
        }

        for (let errorMessage of errorMessages) {
            if (errorMessage !== "") {
                App.showPopupNotification(errorMessage, "error");
            }
        }
    }

    static displayError(erroMsg) {
        if (erroMsg !== "")
            App.showPopupNotification(erroMsg, "error", 100);
            //App.errorNotification.error({
            //    myMessage: erroMsg
            //});
    }
}

export class ServerError {
    message: string;
    path: string;
}

// ============================================================================
// geoloc.ts
// ============================================================================

//class Geoloc {
//    latitude: number = 0;
//    longitude: number = 0;

//    constructor()
//    {
//    }

//    showError(error) {
//        let descriptiveError = "";

//        switch (error.code) {
//            case error.PERMISSION_DENIED:
//                descriptiveError = "User denied the request for Geolocation."
//                break;
//            case error.POSITION_UNAVAILABLE:
//                descriptiveError = "Location information is unavailable."
//                break;
//            case error.TIMEOUT:
//                descriptiveError = "The request to get user location timed out."
//                break;
//            case error.UNKNOWN_ERROR:
//                descriptiveError = "An unknown error occurred."
//                break;
//        }

//        errorNotification.error({
//            myMessage: descriptiveError
//        });
//    }
//}

// ============================================================================
// clock.ts
// ============================================================================

//(function () {

//  var clockElement = document.getElementById( "clock" );

//  function updateClock ( clock ) {
//    clock.innerHTML = new Date().toLocaleTimeString();
//  }

//  setInterval(function () {
//      updateClock( clockElement );
//  }, 1000);

//}());

// ============================================================================
// legacy-noc-info.ts
// ============================================================================

//Used for older logs.
export const legacyNocs = [
    { code: 1, value: "15 Minute Break" },
    { code: 2, value: "Administration" },
    { code: 3, value: "Assist Housekeeping" },
    { code: 4, value: "Car Wash" },
    { code: 5, value: "Internal Investigation" },
    { code: 6, value: "Investigation" },
    { code: 7, value: "Lunch/Meal Break" },
    { code: 8, value: "Meeting" },
    { code: 9, value: "Administration - Other" },
    { code: 10, value: "Out Of Service - Gas/Fuel" },
    { code: 11, value: "Patrol Watch List" },
    { code: 12, value: "Relieve Officer For 15 Minute Break" },
    { code: 13, value: "Relieve Officer For Lunch/Meal" },
    { code: 14, value: "Shift Briefing" },
    { code: 15, value: "Traffic Control" },
    { code: 16, value: "Out At Office" },
    { code: 17, value: "Out At Station" },
    { code: 18, value: "Training - Administration" },
    { code: 19, value: "Training - Batton & Handcuffs" },
    { code: 20, value: "Training - CAD" },
    { code: 21, value: "Training - Community Emergency Response Team" },
    { code: 22, value: "Training - CPR" },
    { code: 23, value: "Training - Dealing With Mentally Disturbed Persons" },
    { code: 24, value: "Training - EMR" },
    { code: 25, value: "Training - Firearms Training" },
    { code: 26, value: "Training - First Aid" },
    { code: 27, value: "Training - General Training" },
    { code: 28, value: "Training - MDT" },
    { code: 29, value: "Training - On The Job Training" },
    { code: 30, value: "Training - Other" },
    { code: 31, value: "Training - Radar Enforcement" },
    { code: 32, value: "Training - Radio Communications" },
    { code: 33, value: "Training - Report Writing" },
    { code: 34, value: "Training - Scheduling" },
    { code: 35, value: "Training - Traffic Stops" },
    { code: 36, value: "Motor Vehicle Accident - With Gun Shot Wound" },
    { code: 37, value: "Motor Vehicle Accident - Fatality" },
    { code: 38, value: "Motor Vehicle Accident - Hit and Run - With Injuries" },
    { code: 39, value: "Motor Vehicle Accident - Involving Motorcycle" },
    { code: 40, value: "Motor Vehicle Accident - Involving Pedestrian" },
    { code: 41, value: "Motor Vehicle Accident - Other (Emergency)" },
    { code: 42, value: "Motor Vehicle Accident - With Injuries" },
    { code: 43, value: "Building Alarm" },
    { code: 44, value: "Burglary Alarm" },
    { code: 45, value: "Commercial Alarm" },
    { code: 46, value: "Fire Alarm" },
    { code: 47, value: "Fire Sprinkler Alarm" },
    { code: 48, value: "Intrusion Alarm" },
    { code: 49, value: "Low Flow Alarm" },
    { code: 50, value: "Motion Alarm" },
    { code: 51, value: "Other Alarm" },
    { code: 52, value: "Panic Alarm" },
    { code: 53, value: "Perimeter Alarm" },
    { code: 54, value: "Unknown Alarm" },
    { code: 55, value: "Vehicle Alarm" },
    { code: 56, value: "Apartment Fire" },
    { code: 57, value: "Debris Fire" },
    { code: 58, value: "House Fire" },
    { code: 59, value: "Fire - Illegal Burning" },
    { code: 60, value: "Mulch Fire" },
    { code: 61, value: "Fire - Other" },
    { code: 62, value: "Structure Fire" },
    { code: 63, value: "Vehicle Fire" },
    { code: 64, value: "Hazardous  Chemicals" },
    { code: 65, value: "Down Power Lines" },
    { code: 66, value: "Hazardous  Electrical" },
    { code: 67, value: "Explosion" },
    { code: 68, value: "Fire" },
    { code: 69, value: "Gas Leak" },
    { code: 70, value: "Hazardous - Other" },
    { code: 71, value: "Sewer Leak" },
    { code: 72, value: "Transformer Blown" },
    { code: 73, value: "Water Leak" },
    { code: 74, value: "Medical - Chest Pains" },
    { code: 75, value: "Dead Body Found" },
    { code: 76, value: "Medical - Fall Injury" },
    { code: 77, value: "Medical - Heart Attack" },
    { code: 78, value: "Medical - Heat Stroke" },
    { code: 79, value: "Medical - Laceration" },
    { code: 80, value: "Mental Health Crisis" },
    { code: 81, value: "Medical - Other" },
    { code: 82, value: "Medical - Person Down" },
    { code: 83, value: "Medical - Shortness Of Breath" },
    { code: 84, value: "Medical - Sick Or Injured Person" },
    { code: 85, value: "Stabbing, Cutting Victim" },
    { code: 86, value: "Suicide" },
    { code: 87, value: "Trouble Breathing" },
    { code: 88, value: "Assault With A Vehicle" },
    { code: 89, value: "DWI / DUI" },
    { code: 90, value: "Public Danger - Other (Driving)" },
    { code: 91, value: "Reckless Driving" },
    { code: 92, value: "Wrong Way Driver" },
    { code: 93, value: "Assault (No Weapon)" },
    { code: 94, value: "Fight In Progress" },
    { code: 95, value: "Homicide" },
    { code: 96, value: "Kidnapping" },
    { code: 97, value: "Public Danger - Other" },
    { code: 98, value: "Rape" },
    { code: 99, value: "Sexual Assault (excl. Rape)" },
    { code: 100, value: "Threat (No Weapon)" },
    { code: 101, value: "Unknown Trouble" },
    { code: 102, value: "Active Shooter" },
    { code: 103, value: "Armed Robbery" },
    { code: 104, value: "Assault (Weapon)" },
    { code: 105, value: "Assault With Deadly Weapon" },
    { code: 106, value: "Bomb Threat" },
    { code: 107, value: "Drive By Shooting" },
    { code: 108, value: "Explosive Device / Bomb" },
    { code: 109, value: "Gun (Subject With Gun)" },
    { code: 110, value: "Knife (Subject With Knife)" },
    { code: 111, value: "Officer Involved In Shooting" },
    { code: 112, value: "Other (Weapon)" },
    { code: 113, value: "Shots Fired" },
    { code: 114, value: "Threat with a Weapon" },
    { code: 115, value: "Burglary In Progress" },
    { code: 116, value: "Robbery / Burglary - Other" },
    { code: 117, value: "Robbery In Progress" },
    { code: 118, value: "Robbery" },
    { code: 119, value: "Abduction / Kidnapping" },
    { code: 120, value: "Air-Sea Rescue" },
    { code: 121, value: "Combat Search and Rescue" },
    { code: 122, value: "Ground Search and Rescue" },
    { code: 123, value: "Missing Person" },
    { code: 124, value: "Mountain Rescue" },
    { code: 125, value: "Search and Rescue (Other)" },
    { code: 126, value: "Urban Search and Rescue" },
    { code: 127, value: "Water Rescue" },
    { code: 128, value: "Aggressive Animal" },
    { code: 129, value: "Animal At Large" },
    { code: 130, value: "Cat Pickup" },
    { code: 131, value: "Dead Animal In Road (Other)" },
    { code: 132, value: "Dead Cat In Road" },
    { code: 133, value: "Dead Dog In Road" },
    { code: 134, value: "Dog Off Leash" },
    { code: 135, value: "Animal - Other" },
    { code: 136, value: "Animal - Pickup" },
    { code: 137, value: "Animal Removal - Armadillos" },
    { code: 138, value: "Animal Removal - Bird" },
    { code: 139, value: "Animal Removal - Coyote" },
    { code: 140, value: "Animal Removal - Deer" },
    { code: 141, value: "Animal Removal - Fox" },
    { code: 142, value: "Animal Removal - Opossum" },
    { code: 143, value: "Animal Removal - Other" },
    { code: 144, value: "Animal Removal - Raccoons" },
    { code: 145, value: "Animal Removal - Rats" },
    { code: 146, value: "Animal Removal - Skunk" },
    { code: 147, value: "Animal Removal - Snake" },
    { code: 148, value: "Follow Up - Fire Investigation" },
    { code: 149, value: "Follow Up - Incident" },
    { code: 150, value: "Follow Up - Other" },
    { code: 151, value: "Follow Up - Police Investigation" },
    { code: 152, value: "Follow Up - Security Investigation" },
    { code: 153, value: "Follow Up - See The Party" },
    { code: 154, value: "Internal Investigation - Loss Prevention Officer Related" },
    { code: 155, value: "Internal Investigation - Loss Prevention Service Related" },
    { code: 156, value: "Internal Investigation - Other" },
    { code: 157, value: "Internal Investigation - Public Safety Officer Conduct" },
    { code: 158, value: "Internal Investigation - Public Safety Service Related" },
    { code: 159, value: "Internal Investigation - Security Guard Service Related" },
    { code: 160, value: "Internal Investigation - Security Officer Conduct" },
    { code: 161, value: "Found Property" },
    { code: 162, value: "Lost Property Report" },
    { code: 163, value: "Maintenance - General Repairs" },
    { code: 164, value: "Maintenance - CCTV" },
    { code: 165, value: "Maintenance - Other" },
    { code: 166, value: "Maintenance - Remote Camera" },
    { code: 167, value: "Maintenance - Vehicle" },
    { code: 168, value: "Maintenance - Vehicle Camera" },
    { code: 169, value: "Motorist Assist - Jump Start" },
    { code: 170, value: "Motorist Assist - Out of Gas" },
    { code: 171, value: "Motorist Assist - Traffic Control" },
    { code: 172, value: "Motorist Assist - Change Tire" },
    { code: 173, value: "Motorist Assist - Fuel" },
    { code: 174, value: "Motorist Assist - Other" },
    { code: 175, value: "Motorist Assist - Unknown Issue" },
    { code: 176, value: "General Service - Other" },
    { code: 177, value: "Assist Another Agency" },
    { code: 178, value: "Check Solicitor" },
    { code: 179, value: "Information Needed" },
    { code: 180, value: "No Code" },
    { code: 181, value: "Protective Detail" },
    { code: 182, value: "Requested Patrol Of Area" },
    { code: 183, value: "Special Assignment" },
    { code: 184, value: "Special Event" },
    { code: 185, value: "Surveillance Detail" },
    { code: 186, value: "Security - Check" },
    { code: 187, value: "Security - Post" },
    { code: 188, value: "Welfare Check -  Open Door (Business)" },
    { code: 189, value: "Welfare Check - Child Neglect" },
    { code: 190, value: "Welfare Check - Children" },
    { code: 191, value: "Welfare Check - Husband" },
    { code: 192, value: "Welfare Check - On Officer" },
    { code: 193, value: "Welfare Check - Open Door (Residence)" },
    { code: 194, value: "Welfare Check - Other" },
    { code: 195, value: "Welfare Check - Unsecured Building (Business)" },
    { code: 196, value: "Welfare Check - Unsecured Building (Residence)" },
    { code: 197, value: "Welfare Check - Wife" },
    { code: 198, value: "Motor Vehicle Accident - Hit and Run - No Injuries" },
    { code: 199, value: "Motor Vehicle Accident - No Injuries" },
    { code: 200, value: "Motor Vehicle Accident - Other (Non-Emergency)" },
    { code: 201, value: "Burglary" },
    { code: 202, value: "Burglary / Theft - Other" },
    { code: 203, value: "Shoplifting" },
    { code: 204, value: "Stolen Vehicle" },
    { code: 205, value: "Stolen Vehicle Recovery" },
    { code: 206, value: "Theft" },
    { code: 207, value: "Bogus Check" },
    { code: 208, value: "Civil Matter" },
    { code: 209, value: "Curfew / Loitering / Vagrancy" },
    { code: 210, value: "Disorderly Conduct" },
    { code: 211, value: "Domestic Violence" },
    { code: 212, value: "Domestic Violence - Fight" },
    { code: 213, value: "Drunk / Intoxicated" },
    { code: 214, value: "Drunks Disturbing" },
    { code: 215, value: "Forgery" },
    { code: 216, value: "Gambling" },
    { code: 217, value: "Harassment / Abuse" },
    { code: 218, value: "Indecent Exposure" },
    { code: 219, value: "Invasion of Privacy" },
    { code: 220, value: "Juveniles Disturbing" },
    { code: 221, value: "Littering" },
    { code: 222, value: "Miscellaneous Animal Incident" },
    { code: 223, value: "Molest" },
    { code: 224, value: "Neighbor Trouble" },
    { code: 225, value: "Noise, Loud Music Disturbing" },
    { code: 226, value: "Obscene Communications" },
    { code: 227, value: "Maintaining Order - Other" },
    { code: 228, value: "Prostitution" },
    { code: 229, value: "Riot" },
    { code: 230, value: "Traffic Congestion" },
    { code: 231, value: "Traffic Control Defect" },
    { code: 232, value: "Traffic Hazard" },
    { code: 233, value: "Trespassing" },
    { code: 234, value: "Property Damage - Criminal" },
    { code: 235, value: "Property Damage - Equipment" },
    { code: 236, value: "Property Damage - Irrigation" },
    { code: 237, value: "Property Damage - Landscape" },
    { code: 238, value: "Property Damage - Lighting" },
    { code: 239, value: "Property Damage - Monument" },
    { code: 240, value: "Property Damage - Other / Unknown" },
    { code: 241, value: "Property Damage - Right of Way" },
    { code: 242, value: "Property Damage - Signage" },
    { code: 243, value: "Property Damage - Stop Sign" },
    { code: 244, value: "Property Damage - Street" },
    { code: 245, value: "Property Damage - Street Sign" },
    { code: 246, value: "Property Damage - Utility Fixture" },
    { code: 247, value: "Suspicious Activity" },
    { code: 248, value: "Suspicious Activity Inside Business" },
    { code: 249, value: "Suspicious Activity Inside Home" },
    { code: 250, value: "Suspicious - Other" },
    { code: 251, value: "Suspicious Person" },
    { code: 252, value: "Suspicious Prowler" },
    { code: 253, value: "Suspicious Vehicle" },
    { code: 254, value: "Abandoned Vehicle" },
    { code: 255, value: "Check For Drugs" },
    { code: 256, value: "Check For Glue Sniffing" },
    { code: 257, value: "Check For Marijuana" },
    { code: 258, value: "City Code Violation" },
    { code: 259, value: "Fish and Game Law" },
    { code: 260, value: "Illegal Parking" },
    { code: 261, value: "Minor In Possession" },
    { code: 262, value: "Violation - Other (Non-Emergency)" },
    { code: 263, value: "Parole Violation" },
    { code: 264, value: "Sell to Minor" },
    { code: 265, value: "Speeding Cars (Drag Racing)" },
    { code: 266, value: "Traffic Stop" },
    { code: 267, value: "Robbery - Home Invasion" },
    { code: 268, value: "Animal Disturbing, Barking Dog" },
    { code: 269, value: "Disturbing Party" },
    { code: 270, value: "Landlord - Tenant Dispute" },
    { code: 271, value: "Theft from Vehicle" },
    { code: 272, value: "Stolen Bicycle" },
    { code: 273, value: "Stolen Property" },
    { code: 274, value: "Recovered Bicycle" },
    { code: 275, value: "Recovered Property" },
    { code: 276, value: "Public Assist" },
    { code: 277, value: "Motor Vehicle Accident - ATV/UTV" },
    { code: 278, value: "Welfare Check -  Pedestrian" },
    { code: 279, value: "Parking violation" },
    { code: 280, value: "Unlawful Discharge of Firearm" },
    { code: 281, value: "Vehicle Impound" },
    { code: 282, value: "Vehicle Recovery / Tow" },
    { code: 283, value: "Assist Sheriffs Office" },
    { code: 284, value: "Assist Fire Department" },
    { code: 285, value: "Assist Ambulance" },
    { code: 286, value: "Assist State Troopers" },
    { code: 287, value: "Assist Border Patrol" },
    { code: 288, value: "Assist Game Warden" },
    { code: 289, value: "Assist Other Agency" },
    { code: 290, value: "Motor Vehicle Accident - RATV" },
    { code: 291, value: "Battery" },
    { code: 292, value: "Medical  - Trauma" },
    { code: 293, value: "Accident Non-Injury Emergency" },
    { code: 294, value: "Unlawful Dumping" },
    { code: 295, value: "Property Check" },
    { code: 296, value: "OHV Registration" },
    { code: 297, value: "Training - ATV Safety Course" },
    { code: 298, value: "Theft from Motor Vehicle" },
    { code: 299, value: "Vandalism - Property" },
    { code: 300, value: "Vandalism - Vehicle" },
    { code: 301, value: "Accident Non-Injury" },
    { code: 302, value: "Accident With Injury" },
    { code: 303, value: "Motorist Assist - Vehicle Stuck" },
    { code: 304, value: "Motorist Assist - Vehicle Disabled" },
    { code: 305, value: "Motorist Assist - Vehicle Tow" },
    { code: 306, value: "Funeral Escort" },
    { code: 307, value: "Vehicle Repossession" },
    { code: 308, value: "Pursuit" },
    { code: 309, value: "Speeding" },
    { code: 310, value: "Failure To Appear" },
    { code: 311, value: "Misdemeanor Warrant" },
    { code: 312, value: "Bail Revoke" },
    { code: 313, value: "Felony Warrant" },
    { code: 314, value: "Stolen License Plates" },
    { code: 315, value: "Fireworks" },
    { code: 316, value: "Vehicle Blocking" },
    { code: 317, value: "Safety Hazard" },
    { code: 318, value: "Illegal Dumping" },
    { code: 319, value: "Parking Issue" },
    { code: 320, value: "Unauthorized Parking" },
    { code: 321, value: "Escort Detail" },
    { code: 322, value: "Unsupervised Children" },
    { code: 323, value: "Eviction Notice" },
    { code: 324, value: "Maintenance Assist" },
    { code: 325, value: "Odor of Marijuana" },
    { code: 326, value: "Public Intoxication" },
    { code: 327, value: "Serving Notices / Papers" },
    { code: 328, value: "Unoccupied Vehicle" },
    { code: 329, value: "Resident Assist" },
    { code: 330, value: "ATM Escorts" },
    { code: 331, value: "Medical - Stroke / CVA" },
    { code: 332, value: "Domestic Dispute" },
    { code: 333, value: "Possession Of A Weapon" },
    { code: 334, value: "Possession Of Drugs" },
    { code: 335, value: "Fugitive Of Justice" },
    { code: 336, value: "Bond Skip" },
    { code: 337, value: "Detained" },
    { code: 338, value: "Local Assistance" },
    { code: 339, value: "Possession Of Identity Or Financial Device" },
    { code: 340, value: "Door Breached" },
    { code: 341, value: "Flash Bang / Smoke Used" },
    { code: 342, value: "Taser Discharged" },
    { code: 343, value: "OC Spray Used" },
    { code: 344, value: "OC Grenade / Tear Gas Used" },
    { code: 345, value: "Transport Tracking" },
    { code: 346, value: "Bail Bonds Warrant" },
    { code: 347, value: "Bail Bonds Violation" },
    { code: 348, value: "GPS Install" },
    { code: 349, value: "GPS maintenance" },
    { code: 350, value: "Arson" },
    { code: 351, value: "Arson Investigation" },
    { code: 352, value: "Motel Ejection" },
    { code: 353, value: "Hotel Ejection" },
    { code: 354, value: "Arrest Made" },
    { code: 355, value: "Field Interview" },
    { code: 356, value: "For Information Only" },
    { code: 357, value: "PR Visit" },
    { code: 358, value: "Refusal To Leave" },
    { code: 359, value: "Maintenance Issue" },
    { code: 360, value: "Panhandling" },
    { code: 361, value: "Hot Shot - Human Waste" },
    { code: 362, value: "Hot Shot - Syringe" },
    { code: 363, value: "Elevator Rescue" },
    { code: 364, value: "Lights Out" },
    { code: 365, value: "Property Lights Check" },
    { code: 366, value: "Homeless / Transit" },
    { code: 367, value: "Gang Member" },
    { code: 368, value: "Expired Tags" },
    { code: 369, value: "In Route Backup" },
    { code: 370, value: "Immediate Assistance" },
    { code: 371, value: "Tow Request" },
    { code: 372, value: "Tow In Progress" },
    { code: 373, value: "Tow In Progress" },
    { code: 374, value: "Vehicle Inspection/PMC" },
    { code: 375, value: "Noise Disturbance" },
    { code: 376, value: "Transient/Individual Removal" },
];
export const legacyNocCodeToValueMap = legacyNocs.reduce(function (map, obj) {
    map[obj.code] = obj.value;
    return map;
}, {});


// ============================================================================
// company-link.ts
// ============================================================================

export class CompanyLink extends EntityBase {
    id: number = null;
    name: string = null;
    status: number = null; //integer, 1 == pending, 2 == active

    constructor(CL?: CompanyLink) {
        super();
        if (CL) {
            this.deserialize(CL);
        }
    }
}


// ============================================================================
// company-vehicle.ts
// ============================================================================

export class CompanyVehicle extends EntityBase {
    constructor(companyVehicle?: CompanyVehicle) {
        super();
        if (companyVehicle) {
            this.deserialize(companyVehicle);
        }
    }

    id: number = null;
    vehicleName: string = null;
}


// ============================================================================
// company-profile.ts
// ============================================================================

export class CompanyProfile {
    constructor(result: any) {
        if (result !== undefined && result !== null) {
            for (let k in result) {
                if (this[k] !== undefined) {
                    this[k] = result[k];
                }
            }

            if (result.companyLogo) {
                this.companyLogo = result.companyLogo;
            }

            if (this.companyLogo) {
                let attachmentInfo: AttachmentInfo = new AttachmentInfo();
                attachmentInfo.id = this.companyLogo.id;
                this.companyLogoInfo = attachmentInfo;
            }
        }
    }

    companyName: string = null; //
    companyAddress1: string = null; //, address line 1 of company
    companyAddress2: string = null; //, address line 2 of company
    companyCity: string = null; //
    companyState: string = null; //
    companyZip: string = null; //
    companyCountry: string = null; //
    companyPhoneNumber: string = null; //
    adminName: string = null; //
    adminPositionTitle: string = null; //
    adminWorkPhone: string = null; //
    adminCellPhone: string = null; //
    adminEmail: string = null; //
    technicalName: string = null; //
    technicalPositionTitle: string = null; //
    technicalWorkPhone: string = null; //
    technicalCellPhone: string = null; //
    technicalEmail: string = null; //
    financeName: string = null; //
    financePositionTitle: string = null; //
    financeWorkPhone: string = null; //
    financeCellPhone: string = null; //
    financeEmail: string = null; //

    companyLogo: Attachment;
    companyLogoInfo: AttachmentInfo;
    timeZoneIdList: Array<NameValue> = [];
    currencyCodeList: Array<NameValue> = [];
    weightUnitsList: Array<NameValue> = [];
    lengthUnitsList: Array<NameValue> = [];

    timeZoneId: number = null;
    currencyCodeDefault: number = null;
    weightUnitsDefault: string = null;
    lengthUnitsDefault: string = null;
}

// ============================================================================
// task.ts
// ============================================================================

export class Task extends EntityBase {
    id: number = null;
    name: string = null;
    defaultDescription: string = null;
    tourExemptionIdList: number[] = [];
    tourExemptionList: any[] = []; // populated by GET /task/get/{id}

    // for front end only
    uniqueId: string;

    constructor(task?: Task) {
        super();
        if (task) {
            this.deserialize(task);
        }
    }
}


// ============================================================================
// task-exemption.ts
// ============================================================================

export class TourExemption extends EntityBase {
    revisionGroup: number = null;
    name: string = null;
    description: string = null;
    isEnabled: boolean = null;


    constructor(tourExemption?: TourExemption) {
        super();
        if (tourExemption) {
            this.deserialize(tourExemption);
        }
    }
}


// ============================================================================
// cc-person.ts
// ============================================================================

export class CCPerson implements ICloneable {
    constructor(result: any) {
        if (result !== undefined && result !== null) {
            for (let k in result) {
                if (this[k] !== undefined) {
                    this[k] = result[k];
                }
            }
        }
    }

    clone() {
        return new CCPerson({
            id: this.id, firstName: this.firstName, lastName: this.lastName,
            dob: getNullableDateClone(this.dob), license: this.license, notes: this.notes, npsdPerson: this.npsdPerson
        });
    }

    id: number = null;
    firstName: string = null;
    lastName: string = null;
    dob: Date = null;
    license: string = null;
    notes: string = null;
    npsdPerson: number = null;
}

// ============================================================================
// cc-vehicle.ts
// ============================================================================

export class CCVehicle implements ICloneable {
    constructor(result: any) {
        if (result !== undefined && result !== null) {
            for (let k in result) {
                if (this[k] !== undefined) {
                    if (k === 'vehicleType') {
                        this.vehicleType = getCCVehicleTypeFromVehicleType(result[k]);
                    } else {
                        this[k] = result[k];
                    }
                }
            }
        }
    }

    clone() {
        return new CCVehicle({
            id: this.id, make: this.make, model: this.model, year: this.year,
            color: this.color, plateState: this.plateState, plateNumber: this.plateNumber,
            vehicleType: this.vehicleType, notes: this.notes, npsdVehicle: this.npsdVehicle
        });
    }

    id: number = null;
    make: string = null;
    model: string = null;
    year: string = null;
    color: string = null;
    plateState: string = null;
    plateNumber: string = null;
    vehicleType: object = null;
    notes: string = null;
    npsdVehicle: number = null;
}

// ============================================================================
// officer.ts
// ============================================================================

export class Officer implements ICloneable {
    constructor(id: number, officer: number, officerName: string, dispatched: Date, whenDispatchedChanged: Date,
        enroute: Date, whenEnrouteChanged: Date, onScene: Date, whenOnSceneChanged: Date,
        cleared: Date, whenClearedChanged: Date, isPrimary: boolean, startingMileage: number, endingMileage: number,
        eventId: string = null, callCardId: number = null, isQueued: boolean = null) {
        this.id = id;
        this.officer = officer;
        this.officerName = officerName;
        this.dispatched = getNullableDateClone(dispatched);
        this.whenDispatchedChanged = getNullableDateClone(whenDispatchedChanged);
        this.enroute = getNullableDateClone(enroute);
        this.whenEnrouteChanged = getNullableDateClone(whenEnrouteChanged);
        this.onScene = getNullableDateClone(onScene);
        this.whenOnSceneChanged = getNullableDateClone(whenOnSceneChanged);
        this.cleared = getNullableDateClone(cleared);
        this.whenClearedChanged = getNullableDateClone(whenClearedChanged);
        this.isPrimary = isPrimary;
        this.startingMileage = startingMileage;
        this.endingMileage = endingMileage;


        this.eventId = eventId;
        this.callCardId = callCardId;
        this.isQueued = isQueued;
    }

    clone() {
        return new Officer(this.id, this.officer, this.officerName, this.dispatched, this.whenDispatchedChanged,
            this.enroute, this.whenEnrouteChanged, this.onScene, this.whenOnSceneChanged,
            this.cleared, this.whenClearedChanged, this.isPrimary, this.startingMileage, this.endingMileage);
    }

    id: number; //id of row for backup unit or null if backup unit is newly added to the call card, always null for primary officer
    officer: number;
    officerName: string;
    dispatched: Date;
    whenDispatchedChanged: Date;
    enroute: Date;
    whenEnrouteChanged: Date;
    onScene: Date;
    whenOnSceneChanged: Date;
    cleared: Date;
    whenClearedChanged: Date;
    isPrimary: boolean;

    startingMileage: number;
    endingMileage: number;

    eventId: string;
    callCardId: number;
    isQueued: boolean;
}

// ============================================================================
// npsd-relationships.ts
// ============================================================================

export class connections {
    people: Array<npsdPersonConnection> = [];
    vehicles: Array<npsdVehicleConnection> = [];
    clients: Array<npsdCGConnection> = [];
    businesses: Array<npsdBusinessConnection> = [];
    reports: Array<NPSDReport> = [];

    constructor(result: any) {
        if (result !== undefined && result !== null) {
            for (let k in result) {
                if (this[k] !== undefined && result[k] !== undefined) {
                    this[k] = result[k];
                }
            }
        }
    }
}

export class UpdateConnections {
    people: Array<npsdPersonConnection> = [];
    vehicles: Array<npsdVehicleConnection> = [];
    clients: Array<npsdCGConnection> = [];
    businesses: Array<npsdBusinessConnection> = [];
    reports: Array<NPSDReport> = [];

    constructor(result: any) {
        if (result.people !== undefined) {
            for (var i = 0; i < result.people.length; i++) {
                const relP = new npsdPersonConnection("");
                relP.id = result.people[i].id;
                relP.relationship = result.people[i].relationship;

                this.people.push(relP);
            }
        }

        if (result.vehicles !== undefined) {
            for (var i = 0; i < result.vehicles.length; i++) {
                const relVeh = new npsdVehicleConnection("");
                relVeh.id = result.vehicles[i].id;
                this.vehicles.push(relVeh);
            }
        }

        if (result.clientGroups !== undefined) {
            for (var i = 0; i < result.clientGroups.length; i++) {
                const relCG = new npsdCGConnection("");
                relCG.id = result.clientGroups[i].id;
                relCG.roles = result.clientGroups[i].roles;

                this.clients.push(relCG);
            }
        }

        if (result.businesses !== undefined) {
            for (var i = 0; i < result.businesses.length; i++) {
                const relBus = new npsdBusinessConnection("");
                relBus.id = result.businesses[i].id;
                relBus.roles = result.businesses[i].roles;

                this.businesses.push(relBus);
            }
        }
    }
}

export class npsdPersonConnection {
    constructor(result: any) {
        if (result !== undefined && result !== null) {
            for (let k in result) {
                if (this[k] !== undefined && result[k] !== undefined) {
                    this[k] = result[k];
                }
            }
        }
    }

    id: number = null;
    relationship: number = null;
    notes: string = null;
    firstName: string = null;
    lastName: string = null;
    dob: string = null;
}

export class npsdVehicleConnection {
    constructor(result: any) {
        if (result !== undefined && result !== null) {
            for (let k in result) {
                if (this[k] !== undefined && result[k] !== undefined) {
                    this[k] = result[k];
                }
            }
        }
    }

    id: number = null;
    plateNumber: string = null;
    plateState: string = null;
    make: string = null;
    model: string = null;
    color: string = null;
    vin: string = null;
}

export class npsdBusinessConnection {
    constructor(result: any) {
        if (result !== undefined && result !== null) {
            for (let k in result) {
                if (this[k] !== undefined && result[k] !== undefined) {
                    this[k] = result[k];
                }
            }
        }
    }

    id: number = null;
    businessName: string = null;
    branchName: string = null;
    website: string = null;
    roles: string = null;
}

export class npsdCGConnection {
    constructor(result: any) {
        if (result !== undefined && result !== null) {
            for (let k in result) {
                if (this[k] !== undefined && result[k] !== undefined) {
                    this[k] = result[k];
                }
            }
        }
    }

    id: number = null;
    name: string = null;
    locCity: string = null;
    locState: string = null;
    website: string = null;
    roles: string = null;
}

export enum RelType {
    person,
    vehicle,
    business,
    client
}

export enum RelTypePlural {
    people,
    vehicles,
    businesses,
    clients
}

export class Warning {
    id: number;
    priority: number;
    warning: string;
}

export class GateCode {
    id: number;
    gateCode: string;
}


export function updateRelationships(Item: any, e: any, relType: RelType, type: string) {
    let connectionsOld: connections;

    let connectionsNew: connections;

    const id = Item.id.toString();
    var itemId = e.model.id;

    //connectionsOld = new UpdateConnections(Item.connections);
    //connectionsNew = new UpdateConnections(Item.connections);

    let arr;
    if (relType === RelType.person) {
        arr = currentPerson.connectionsNew[type];
    }
    else if (relType === RelType.business) {
        arr = currentBusiness.connectionsNew[type];
    }
    else if (relType === RelType.vehicle) {
        arr = currentVehicle.connectionsNew[type];
    }
    else if (relType === RelType.client) {
        arr = currentClientGroup.connectionsNew[type];
    }
    if (arr) {
        const removeIdx = arr.findIndex(e => (e["id"] == itemId));
        if (removeIdx > -1) arr.splice(removeIdx, 1);
    }
}

export function getCurrentNPSDType() {
    let nspdType;

    // Check modal state for call card context
    const ccVue = App.callCardController;
    if (ccVue?.showPersonModal) {
        return RelType.person;
    } else if (ccVue?.showVehicleModal) {
        return RelType.vehicle;
    } else if (ccVue?.showClientModal) {
        return RelType.client;
    }

    // If we are not getting the npsd reltype from within a modal, get it by viewing the page url.
    const currentUrl = window.location.pathname;
    if (currentUrl.indexOf("Person") > -1 || currentUrl.indexOf("person") > -1) {
        return RelType.person;
    }
    else if (currentUrl.indexOf("Business") > -1 || currentUrl.indexOf("business") > -1) {
        return RelType.business;
    }
    else if (currentUrl.indexOf("Vehicle") > -1 || currentUrl.indexOf("vehicle") > -1) {
        return RelType.vehicle;
    }
    else if (currentUrl.indexOf("ClientGroup") > -1 || currentUrl.indexOf("client-group") > -1) {
        return RelType.client;
    }
}

// ============================================================================
// person.ts
// ============================================================================

export class Person {
    constructor(result: any) {
        if (result !== undefined && result !== null) {
            for (let k in result) {
                if (this[k] !== undefined) {
                    this[k] = result[k];
                }
            }
        }

        if (result.connections) {
            this.connections = new connections(deepCopyProperties(result.connections));
            this.connectionsOld = new connections(deepCopyProperties(result.connections));
            // connectionsNew should only contain NEW connections added during this session
            this.connectionsNew = new connections("");
        }

        if (!hasValue(this.attachmentList)) {
            this.attachmentList = [];
        }
        this.attachmentInfoList = [];
        for (let i = 0; i < this.attachmentList.length; i++) {
            const attachment = new AttachmentInfo();
            attachment.id = this.attachmentList[i].id;
            this.attachmentInfoList.push(attachment);
        }
        this.descriptionPicInfoId = this.descriptionPicId;

        if (this.weight === null)
            this.weight = new weight("");

        if (this.height === null)
            this.height = new height("");
    }

    public static isDateField(name: any) {
        if (name === "dob" ||
            name === "driversLicenseIssued" ||
            name === "driversLicenseExpires") {
            return true;
        }
        else
            return false;
    }

    id: number = null;
    firstName: string = null;
    lastName: string = null;
    middleName: string = null;
    suffix: string = null;
    address1: string = null;
    address2: string = null;
    city: string = null;
    state: string = null;
    zip: string = null;

    aliases: string = null; // aliases
    employeeId: string = null; // employee ID (badge number, etc.)
    employer: string = null; // employer

    dob: Date = null;
    gender: number = null; // code for gender
    race: number = null; // code for race

    height: height = new height("");
    weight: weight = new weight("");

    personHeightMeters: string;
    personHeightFeet: string;
    personHeightInches: string;
    personWeight: string = "";
    createdByCompanyId: number = null;
    createdByCompanyName: string = null;

    eyeColor: number = null; // eye color
    hairColor: number = null; // hair color
    notes: string = null; // notes
    locName: string = null; // location name
    locAddress: string = null; // location address line 1
    locAddress2: string = null; // location address line 2
    locCity: string = null; // location city
    locState: string = null; // location state
    locZip: string = null; // location zip
    locCountry: string = null; // location country
    locFormattedAddress: string = null;
    latitude: number = null;
    longitude: number = null;
    customLocationId: boolean = null;
    driversLicenseNum: string = null; // government ID number
    driversLicenseType: number = null; // ID type: 1=DL, 2=State ID, 3=Passport, 4=Military, 5=Other
    driversLicenseClass: string = null; // drivers license class
    driversLicenseIssued: Date = null; // drivers license issuance Date
    driversLicenseExpires: Date = null; // drivers license expires Date
    driversLicenseState: string = null; // drivers license state
    driversLicenseRestrictions: string = null; // drivers license restrictions
    phoneNumbers: Array<PhoneNumber> = [];
    emails: Array<Email> = [];

    descriptionPicId: number = null;  //attachmentList element id (i.e. an id of one of the attachments form attachmentList)
    descriptionPicInfoId: number = null;  //attachmentInfoList element id (i.e. an id of one of the attachments form attachmentInfoList)
    attachmentList: Array<Attachment> = [];
    attachmentInfoList: Array<AttachmentInfo> = [];

    connections: connections = new connections("");
    warnings: Array<Warning> = [];

    connectionsOld: connections = new connections("");
    connectionsNew: connections = new connections("");

    citationCount: number = null;
}

export class height {
    constructor(result: any) {
        if (result !== undefined && result !== null) {
            for (let k in result) {
                if (this[k] !== undefined) {
                    this[k] = result[k];
                }
            }
        }
    }

    displayUnits: string = hUnits[hUnits.ft];
    mm: number = 0;
}

export class weight {
    constructor(result: any) {
        if (result !== undefined && result !== null) {
            for (let k in result) {
                if (this[k] !== undefined) {
                    this[k] = result[k];
                }
            }
        }
    }

    displayUnits: string = wUnits[wUnits.lbs];
    grams: number = 0;
}

export enum hUnits {
    ft,
    m
}

export enum wUnits {
    lbs,
    kg
}

export var currentPerson: Person;

export var NPSDPersonToAdd: Person;
export var NPSDBusinessToAdd: Business;
export var NPSDCGToAdd: ClientGroup;
export var NPSDVehicleToAdd: Vehicle;

export function Open_Person(id: string, isWindow: boolean = false, unknown: boolean = false, edit: boolean = false) {
    App.setProgressControl();

    // Use React Router navigation
    const nav = (window as any).OrnaReact?.navigate;
    if (id) {
        if (nav?.toPerson) {
            nav.toPerson(id);
        } else {
            console.error('Person screen navigation not available');
        }
    } else {
        if (nav?.toNewPerson) {
            nav.toNewPerson();
        } else {
            console.error('Person screen navigation not available');
        }
    }
}

export function openNewCitationForPerson() {
    // Open new citation form with current person
    if (currentPerson && currentPerson.id) {
        window.OrnaReact.navigate.toNewCitation(currentPerson.id);
    }
}


// ============================================================================
// vehicle.ts
// ============================================================================

export class Vehicle {
    constructor(result: any) {
        if (result !== undefined && result !== null) {
            for (let k in result) {
                if (this[k] !== undefined) {
                    this[k] = result[k];
                }
            }
        }

        if (result.connections) {
            this.connections = new connections(deepCopyProperties(result.connections));

            this.connectionsOld = new connections(deepCopyProperties(result.connections));

            // connectionsNew should only contain NEW connections added during this session
            // NOT existing connections (those are already in the database)
            this.connectionsNew = new connections("");
        }

        if (!hasValue(this.attachmentList)) {
            this.attachmentList = [];
        }
        this.attachmentInfoList = [];
        for (let i = 0; i < this.attachmentList.length; i++) {
            const attachment = new AttachmentInfo();
            attachment.id = this.attachmentList[i].id;
            this.attachmentInfoList.push(attachment);
        }
        this.descriptionPicInfoId = this.descriptionPicId;
    }

    public static isDateField(name: any) {
        if (name === "plateIssued" ||
            name === "plateExpires") {
            return true;
        }
        else
            return false;
    }

    id: number = null;
    make: string = null;
    model: string = null;
    year: string = null;
    color: string = null;
    plateState: string = null;
    plateNumber: string = null;

    plateCountry: string = null;// license plate country
    temporaryPlate: string = null;//, is license plate temporary plate (1 = YES, 2 = NO, 3 = N / A)
    plateIssued: Date = null;//, date license plate issued
    plateExpires: Date = null;//, date license plate expiration date
    insuranceCompanyName: string = null;//, license plate insurance company
    insuranceExpires: Date = null;//, license plate insurance expiration date
    insurancePolicyNumber: string = null;//, license plate insurance policy #
    insuranceCompanyPhone: string = null;//, license plate insurance company phone #
    vin: string = null;
    bodyStyle: string = null;// body style
    vehicleType: number = null;
    notes: string = null;//, notes
    descriptionPicId: number = null;  //attachmentList element id (i.e. an id of one of the attachments form attachmentList)
    descriptionPicInfoId: number = null;  //attachmentInfoList element id (i.e. an id of one of the attachments form attachmentInfoList)
    attachmentList: Array<Attachment> = [];
    attachmentInfoList: Array<AttachmentInfo> = [];
    createdByCompanyId: number = null;
    createdByCompanyName: string = null;

    warnings: Array<Warning> = [];

    connections: connections = new connections("");
    connectionsOld: connections = new connections("");
    connectionsNew: connections = new connections("");
}

export var vehicleDetailVue: any = null;
export var currentVehicle: Vehicle = null;

export function Open_Vehicle(id: string, openInWindow: boolean = false, isUnknown: boolean = false, startInEditMode: boolean = false) {
    App.setProgressControl();

    // Use React Router navigation
    const nav = (window as any).OrnaReact?.navigate;
    if (id) {
        if (nav?.toVehicle) {
            nav.toVehicle(id);
        } else {
            console.error('Vehicle screen navigation not available');
        }
    } else {
        if (nav?.toNewVehicle) {
            nav.toNewVehicle();
        } else {
            console.error('Vehicle screen navigation not available');
        }
    }
}



// ============================================================================
// business.ts
// ============================================================================

export class Business {
    public id: number = null;
    public businessName: string = null;// business name
    branchName: string = null;// branch name
    website: string = null;// website url
    businessType: string = null;// business type
    notes: string = null;// notesa
    locName: string = null;// location name
    locAddress: string = null;// location address line 1
    locAddress2: string = null;// location address line 2
    locCity: string = null;// location city
    locState: string = null;// location state
    locZip: string = null;// location zip
    locCountry: string = null;// location country
    locFormattedAddress: string = null;
    latitude: number = null;
    longitude: number = null;
    customLocationId: boolean = null;
    emails: Array<Email> = [];
    descriptionPicInfoId: number = null;  //attachmentInfoList element id (i.e. an id of one of the attachments form attachmentInfoList)
    attachmentList: Array<Attachment> = [];
    attachmentInfoList: Array<AttachmentInfo> = [];

    createdByCompanyId: number = null;
    createdByCompanyName: string = null;

    phoneNumbers: Array<PhoneNumber> = [];
    warnings: Array<Warning> = [];

    addConnections = {};

    connections: connections = new connections("");
    connectionsOld: connections = new connections("");
    connectionsNew: connections = new connections("");

    constructor(result: any) {
        if (result !== undefined && result !== null) {
            for (let k in result) {
                if (this[k] !== undefined) {
                    this[k] = result[k];
                }
            }
        }

        if (!hasValue(this.attachmentList)) {
            this.attachmentList = [];
        }
        this.attachmentInfoList = [];
        for (let i = 0; i < this.attachmentList.length; i++) {
            const attachment = new AttachmentInfo();
            attachment.id = this.attachmentList[i].id;
            this.attachmentInfoList.push(attachment);
        }

        if (result.connections) {
            this.connections = new connections(deepCopyProperties(result.connections));

            this.connectionsOld = new connections(deepCopyProperties(result.connections));

            // connectionsNew should only contain NEW connections added during this session
            // NOT existing connections (those are already in the database)
            this.connectionsNew = new connections("");
        }
    }
}

export var currentBusiness: Business;

export function Open_Business(id: string, openInWindow: boolean = false, isUnknown: boolean = false, startInEditMode: boolean = false) {
    App.setProgressControl();

    // Use React Router navigation
    const nav = (window as any).OrnaReact?.navigate;
    if (id) {
        if (nav?.toBusiness) {
            nav.toBusiness(id);
        } else {
            console.error('Business screen navigation not available');
        }
    } else {
        if (nav?.toNewBusiness) {
            nav.toNewBusiness();
        } else {
            console.error('Business screen navigation not available');
        }
    }
}


// ============================================================================
// client-group.ts
// ============================================================================

export class ClientGroup {
    id: number = null;
    name: string = null; // client name
    website: string = null; // website url
    notes: string = null; // notes
    locName: string = null; // location name
    locAddress: string = null; // location address line 1
    locAddress2: string = null; // location address line 2
    locCity: string = null; // location city
    locState: string = null; // location state
    locZip: string = null; // location zip
    locCountry: string = null; // location country
    locFormattedAddress: string = null;
    latitude: number = null;
    longitude: number = null;
    customLocationId: boolean = null;

    accountNumber: string = null;
    authorizationCode: string = null;

    notificationDefaultTimeZoneId: string = null;
    notificationDefaultTime: number = null;

    emails: Array<Email> = [];
    descriptionPicInfoId: number = null;  //attachmentInfoList element id (i.e. an id of one of the attachments form attachmentInfoList)
    attachmentList: Array<Attachment> = [];
    attachmentInfoList: Array<AttachmentInfo> = [];

    sites: Array<ClientGroupSite> = [];
    automatedNotificationList: Array<ClientAutomatedNotification> = []

    phoneNumbers: Array<PhoneNumber> = [];
    warnings: Array<Warning> = [];
    gateCodes: Array<GateCode> = [];

    connections: connections = new connections("");
    connectionsOld: connections = new connections("");
    connectionsNew: connections = new connections("");

    constructor(result: any) {
        if (result !== undefined && result !== null) {
            for (let k in result) {
                if (this[k] !== undefined) {
                    this[k] = result[k];
                }
            }
        }

        if (result.connections) {
            this.connections = new connections(deepCopyProperties(result.connections));

            this.connectionsOld = new connections(deepCopyProperties(result.connections));

            // connectionsNew should only contain NEW connections added during this session
            // NOT existing connections (those are already in the database)
            this.connectionsNew = new connections("");
        }

        if (!hasValue(this.attachmentList)) {
            this.attachmentList = [];
        }
        this.attachmentInfoList = [];
        for (let i = 0; i < this.attachmentList.length; i++) {
            const attachment = new AttachmentInfo();
            attachment.id = this.attachmentList[i].id;
            this.attachmentInfoList.push(attachment);
        }
    }
}

export let isClientGroupAdmin = false;
export let currentClientGroup: ClientGroup;
export function Open_AdminClientGroup(id: string) {
    isClientGroupAdmin = true;
    Open_ClientGroup(id);
}

export function Open_ClientGroup(id: string, openInWindow: boolean = false, edit: boolean = false) {
    App.setProgressControl();

    // Use React Router navigation
    const nav = (window as any).OrnaReact?.navigate;
    if (id) {
        if (nav?.toClientGroup) {
            nav.toClientGroup(id);
        } else {
            console.error('Client group screen navigation not available');
        }
    } else {
        console.error('Client group screen navigation not available');
    }
}


// ============================================================================
// citation.ts
// ============================================================================

export interface OffenderSnapshot {
    id: number;
    firstName: string;
    lastName: string;
    middleName: string;
    suffix: string;
    dateOfBirth: string;  // YYYY-MM-DD format
    address: string;
    city: string;
    state: string;
    zip: string;
    phone: string;
    email: string;
    idType: number;       // 1=DL, 2=State ID, 3=Passport, 4=Military, 5=Other
    idNumber: string;
    idState: string;
    employeeId: string;
    employer: string;
    gender: number;
    race: number;
    height: string;
    weight: string;
    hairColor: number;
    eyeColor: number;
}

export interface VehicleSnapshot {
    plateNumber: string;
    plateState: string;
    plateStateValue: string;
    make: string;
    makeValue: string;
    model: string;
    modelValue: string;
    year: number;
    color: string;
    colorValue: string;
    vin: string;
}

// Trespass status enum values per API spec
type TrespassStatus = 'police' | 'verbal' | 'none' | null;

export interface CitationListItem {
    id: number;
    citationNumber: string | null;
    status: string;
    dateOfIssuance: string;
    offenderName: string;
    npsdPersonId: number;
    violationTypes: number[];
    violationTypeValues: string[];
    propertyLocation: string;
    offenseLocation: string;
    fineAmount: number | null;
    fineToBeDetermined: boolean;
    callCardId: number | null;
    eventId: string | null;
    issuingOfficerName: string;
    createdDate: string;
    modifiedDate: string;
    voidedBy: number | null;
    voidedByName: string | null;
}

export const CITATION_STATUS = {
    draft: 'draft',
    issued: 'issued',
    voided: 'voided'
};

export class Citation {
    constructor(result: any) {
        if (result !== undefined && result !== null) {
            for (let k in result) {
                if (this[k] !== undefined) {
                    if (Citation.isDateField(k)) {
                        this[k] = result[k] !== null ? new Date(result[k]) : null;
                    } else {
                        this[k] = result[k];
                    }
                }
            }
        }

        if (!hasValue(this.attachmentList)) {
            this.attachmentList = [];
        }
    }

    public static isDateField(name: any) {
        if (name === "dateOfIssuance" ||
            name === "createdDate" ||
            name === "modifiedDate" ||
            name === "voidedDate" ||
            name === "offenseDateTime" ||
            name === "trespassDateTime" ||
            name === "courtDateTime") {
            return true;
        }
        return false;
    }

    id: number = null;
    citationNumber: string = null;

    // Status & Workflow
    status: string = 'draft';
    voidedReason: string = null;
    voidedBy: number = null;
    voidedByName: string = null;
    voidedDate: Date = null;

    // Audit Fields
    createdBy: number = null;
    createdByName: string = null;
    createdDate: Date = null;
    modifiedBy: number = null;
    modifiedByName: string = null;
    modifiedDate: Date = null;

    // Header
    dateOfIssuance: Date = null;
    issuingOfficerId: number = null;
    issuingOfficerName: string = null;
    issuingOfficerBadgeNumber: string = null;
    issuingOfficerAgency: string = null;
    propertyLocation: string = null;

    // Offender Reference
    npsdPersonId: number = null;

    // Offender Snapshot (captured at issuance, immutable)
    offenderSnapshot: OffenderSnapshot = null;

    /**
     * Call Card Reference (optional)
     * If provided, must reference a valid call card belonging to the same company.
     * Used to link citations to CAD events for tracking purposes.
     * @see spec line 802 - optional, must be valid call card if provided
     */
    callCardId: number = null;

    // Violation
    violationTypes: number[] = [];
    otherViolation: string = null;
    offenseDateTime: Date = null;
    offenseLocation: string = null;
    allegedSpeed: number = null;
    speedLimit: number = null;

    // Vehicle Reference (optional)
    npsdVehicleId: number = null;

    // Vehicle Snapshot (captured at issuance if vehicle linked)
    vehicleSnapshot: VehicleSnapshot = null;

    // Fine
    fineAmount: number = null;
    fineToBeDetermined: boolean = false;

    // Internal Only (never on public PDF)
    probableCauseNarrative: string = null;
    bodyCamReference: string = null;
    cadEventNumber: string = null;
    attachmentList: Array<Attachment> = [];

    // Trespass (included on public PDF)
    trespassStatus: TrespassStatus = null;
    policeCaseNumber: string = null;
    trespassDateTime: Date = null;

    // Acknowledgment
    signatureAttachmentId: number = null;
    signatureAttachmentActivationKey: string = null;  // Required when providing signatureAttachmentId for new uploads
    signatureUrl: string = null;  // Signed URL for displaying the signature image
    signatureRefused: boolean = false;

    // Notes
    notes: string = null;

    // Court (optional, feature-flagged)
    courtDateTime: Date = null;
}


// ============================================================================
// report.ts
// ============================================================================

export class mdtReport {
    constructor(result: any) {
        if (result !== undefined && result !== null) {
            for (let k in result) {
                if (this[k] !== undefined) {
                    if (k === "accident") {
                        this.accident = new Accident(result[k]);
                    } else if (k === "medicalReports") {
                        for (var i = 0; i < result[k].length; i++) {
                            this.medicalReports.push(new MedicalReport(result[k][i]));
                        }
                    }
                    else if (k === "propertyList") {
                        for (var i = 0; i < result[k].length; i++) {
                            this.propertyList.push(new Property(result[k][i]));
                        }
                    }
                    else if (k === "statementList") {
                        for (var i = 0; i < result[k].length; i++) {
                            this.statementList.push(new Statement(result[k][i]));
                        }
                    }
                    else if (k === "digitalEvidenceList") {
                        for (var i = 0; i < result[k].length; i++) {
                            this.digitalEvidenceList.push(new DigitalEvidence(result[k][i]));
                        }
                    }
                    else if (k === "offenders") {
                        for (var i = 0; i < result[k].length; i++) {
                            this.offenders.push(new Offender(result[k][i]));
                        }
                    }
                    else if (k === "backupUnits") {
                        for (var i = 0; i < result[k].length; i++) {
                            this.backupUnits.push(new BackUpUnit(result[k][i]));
                        }
                    }
                    else if (k === "respondingAgencies") {
                        for (var i = 0; i < result[k].length; i++) {
                            this.respondingAgencies.push(new RespondingAgency(result[k][i]));
                        }
                    }
                    //else if (k === "npsd") {
                    //    for (var i = 0; i < result[k].people.length; i++) {
                    //        this.npsdPeople.push(new npsdRead(result[k].people));
                    //    }
                    //}
                    else {
                        if (mdtReport.isDateField(k)) {
                            let curResult = result[k];
                            if ((curResult !== null) && (curResult !== undefined)) {
                                this[k] = new Date(curResult);
                            }
                        } else {
                            this[k] = result[k];
                        }
                    }
                }
            }
        }

        if (result !== undefined && result !== null && result !== "")
            this.setNPSDNewRelationships(result.npsd);
    }

    setNPSDNewRelationships(result) {
        for (var i = 0; i < result.businesses.length; i++) {
            const business = result.businesses[i];

            const rptBusinessOld = new ReportBusiness(business);
            const rptBusinessNew = new ReportBusiness(business);
            this.npsdConnectionsOld.businesses.push(rptBusinessOld);
            this.npsdConnectionsNew.businesses.push(rptBusinessNew);
        }

        for (var i = 0; i < result.clients.length; i++) {
            const client = result.clients[i];

            const rptClientOld = new ReportClientGroup(client);
            const rptClientNew = new ReportClientGroup(client);
            this.npsdConnectionsOld.clients.push(rptClientOld);
            this.npsdConnectionsNew.clients.push(rptClientNew);
        }

        for (var i = 0; i < result.people.length; i++) {
            const person = result.people[i];

            const rptPersonOld = new ReportPerson(person);
            const rptPersonNew = new ReportPerson(person);

            this.npsdConnectionsOld.people.push(rptPersonOld);
            this.npsdConnectionsNew.people.push(rptPersonNew);
        }

        for (var i = 0; i < result.vehicles.length; i++) {
            const vehicle = result.vehicles[i];

            const rptVehicleOld = new ReportVehicle(vehicle);
            const rptVehicleNew = new ReportVehicle(vehicle);
            this.npsdConnectionsOld.vehicles.push(rptVehicleOld);
            this.npsdConnectionsNew.vehicles.push(rptVehicleNew);
        }
    }

    public static isDateField(name: any) {
        if (name === "callDateTime" ||
            name === "primaryDispatched" ||
            name === "primaryEnroute" ||
            name === "primaryOnScene" ||
            name === "primaryCleared" ||

            name === "incidentOccurredFrom" ||
            name === "incidentOccurredTo" ||
            name === "notifiedOfIncidentTime" ||

            name === "dob") {
            return true;
        }
        else
            return false;
    }

    id: number = null;
    caseId: string = "";
    lockedFor: number = null; // GET ONLY = null; null if not locked, and time in milliseconds until no longer locked if the report is locked

    authorId: number = null; // - GET ONLY - long, id of author
    authorTimeZoneId: string = null; // - POST ONLY, time zone id of author
    isSubmitted: boolean = null; // - GET ONLY - bool, true if report is submitted and false otherwise
    isApproved: boolean = null; // - GET ONLY - bool, true if report is approved and false otherwise
    callCardId: number = null; // - POST ONLY - long, id of call card if report is from a call card

    originalPDF: any = null; //todo: add type

    isInternalInvestigator: boolean = null;//GET ONLY = null; boolean, if true: include Internal Investigator code "034" in NOC dropdown.For creating a new report, please check submodules returned by / api / module / select

    reportSubmittedForApproval: boolean = null; // POST, PUT ONLY = null; bool, true if "Submit for Approval" button used to save/ update this report is clicked
    returnToAuthorComments: string = ""; // POST, PUT ONLY = null; string, supervisor only = null; comments returned to author when supervisor sends report back to MDT after "Return to Author" button is clicked on the report and the "Return to Author" button on the popup is clicked
    reportApproved: boolean = null; // POST, PUT ONLY = null; bool, true if "Approve" button on supervisor screen is clicked
    reportSubmitted: Boolean = null; // is "submit report" button used to save/ update this report

    natureOfCall: Array<number> = null; // nature of call
    natureOfCallValues: Array<string> = null; //nature of call values
    incidentDescription: string = ""; // incident description
    incidentOccurredFrom: Date = null; // call occurred start
    incidentOccurredTo: Date = null; // call occured end
    notifiedOfIncidentVia: number = null; // notified incident via (use map to look up text from integer)
    notifiedOfIncidentTime: Date = null; // call received

    notifiedPerson: number = null; // id of officer call was received by
    //notifiedPersonObject = null; //

    notifiedAs: number = null; // notified as (use map to look up text from integer)

    callLocName: string = ""; // location name of incident
    callLocAddress: string = ""; // address of incident
    callLocAddress2: string = ""; // address line 2 of incident (on screenshots = null; // shown as Apt)
    callLocCity: string = ""; // city of incident
    callLocState: string = ""; // two letter state abbreviation of incident
    callLocZip: string = ""; // zip code of incident
    callLocCountry: string = "";
    callLocFormattedAddress: string = "";
    latitude: number = null;
    longitude: number = null;
    customLocationId: boolean = null;

    callDisposition: number = null; // - GET ONLY - string, call disposition from call card if it exists
    callDispositionValue: string = null;
    dispositionNotes: string = null; // - GET ONLY - string, disposition notes from call card if it exists

    // (note that primaryOfficer is not listed here as it cannot be changed)
    primaryOfficer: number = null;
    primaryDispatched: Date = null; // time primary officer dispatched
    primaryEnroute: Date = null; // time primary officer enroute
    primaryOnScene: Date = null; // time primary officer on- scene
    primaryCleared: Date = null; // time primary officer cleared

    backupUnits: Array<BackUpUnit> = [];
    respondingAgencies: Array<RespondingAgency> = [];

    npsdConnectionsOld: npsdReportConnections = new npsdReportConnections();
    npsdConnectionsNew: npsdReportConnections = new npsdReportConnections();

    offenders: Array<Offender> = [];
    accident: Accident = new Accident("");
    propertyList: Array<Property> = [];
    medicalReports: Array<MedicalReport> = [];
    statementList: Array<Statement> = [];
    digitalEvidenceList: Array<DigitalEvidence> = [];

    narrative: string = "";
    narrativeAttachmentInfoList: Array<AttachmentInfo> = [];

    //npsdPeople: Array<npsdRead> = [];

    //{
    //    connection: rptConnection = null;

    //}
}

//class npsdRead {
//    constructor(result: any) {
//        if (result !== undefined && result !== null) {
//            for (let k in result) {
//                if (this[k] !== undefined && result[k] !== undefined) {
//                    this[k] = result[k];
//                }
//            }
//        }
//    }

//    connection: connection = new connection();
//    dob: Date = null;
//    firstName: string = "";
//    gender: number = null;
//    id: number = null;
//    lastName: string = "";
//    middleName: string = "";
//    race: number = null;
//}

//class rptConnection {
//    constructor(result: any) {
//        if (result !== undefined && result !== null) {
//            for (let k in result) {
//                if (this[k] !== undefined && result[k] !== undefined) {
//                    this[k] = result[k];
//                }
//            }
//        }
//    }

//    roles: Array<number>;
//    associates: Array<npsdAssociates>;
//}

//class npsdAssociates {
//    id: number = null;
//    notes: string = "";
//    person: string = "";
//    relationship: number = null;
//}

export class npsdReportConnections {
    clients: Array<ReportClientGroup> = [];
    businesses: Array<ReportBusiness> = [];
    people: Array<ReportPerson> = [];
    vehicles: Array<ReportVehicle> = [];
}

export class ReportClientGroup {
    id: number = null;
    name: string;
    sites: Array<number> = [];
    allSites: Array<any> = [];

    constructor(result: any = null) {
        if (result !== undefined && result !== null) {
            for (let k in result) {
                if (k === 'sites') {
                    this.sites = result[k] ? result[k].slice(0) : [];
                } else {
                    this[k] = result[k];
                }
            }
        }
    }
}

export class ReportBusiness {
    id: number;
    businessName: string;
    branchName: string;
    website: string;
    connections: any;

    constructor(result: any = null) {
        if (result !== undefined && result !== null) {
            for (let k in result) {
                if (this.hasOwnProperty(k) || k === 'id' || k === 'businessName' || k === 'branchName' || k === 'website' || k === 'connections') {
                    this[k] = result[k];
                }
            }
        }
    }
}

export class ReportPerson {
    id: number;
    firstName: string;
    lastName: string;
    middleName: string;
    dob: Date;
    gender: number;
    race: number;
    connections: any;
    roles: Array<number> = [];

    constructor(result: any = null) {
        if (result !== undefined && result !== null) {
            for (let k in result) {
                if (k === 'connections') {
                    this.connections = result[k];
                    if (result[k] && result[k].roles) {
                        this.roles = result[k].roles;
                    }
                } else {
                    this[k] = result[k];
                }
            }
        }
    }
}

export class ReportVehicle {
    id: number;
    make: string;
    model: string;
    year: string;
    color: string;
    plateNumber: string;
    plateState: string;
    connections: any;

    constructor(result: any = null) {
        if (result !== undefined && result !== null) {
            for (let k in result) {
                if (this.hasOwnProperty(k) || k === 'id' || k === 'make' || k === 'model' || k === 'year' || k === 'color' || k === 'plateNumber' || k === 'plateState' || k === 'connections') {
                    this[k] = result[k];
                }
            }
        }
    }
}

// ============================================================================
// call-alert.ts
// ============================================================================

export class CallAlert extends EntityBase {
    constructor(callAlert?: CallAlert) {
        super();
        if (callAlert) {
            this.deserialize(callAlert);
        }
    }

    id: number = null;//, ID of tour stop
    locFormattedAddress: string = null;
    callAlertTypeId: number = null;
    alertStartTime: string = null;
    alertEndTime: string = null;
    message: string = null;

    latitude: number = null;
    longitude: number = null;
    customLocationId: boolean = null;
}


// ============================================================================
// tour.ts
// ============================================================================

export class Tour extends EntityBase {
    id: number = null;
    tourIdToCopyTourStops: number = null;
    timeZoneId: string = Intl.DateTimeFormat().resolvedOptions().timeZone;
    title: string = null;
    type: number = null;
    isEnabled: boolean = true;
    tourAvailabilityList: Array<TourAvailability> = new Array<TourAvailability>();

    MinStartTime: string = null;
    MaxEndTime: string = null;

    constructor(tour?: Tour) {
        super();
        if (tour) {
            this.deserialize(tour);
            this.tourAvailabilityList = this.tourAvailabilityList.map(ta => new TourAvailability(ta));
        }
    }

    get TourAvailabilityList(): Array<TourAvailability> {
        return this.tourAvailabilityList;
    }

    get DaysOfWeek(): Array<WeekDay> {
        return JSON.parse(JSON.stringify(WeekDays));
    }
}

export class TourAvailability extends EntityBase {
    constructor(tourAvailability?: TourAvailability) {
        super();
        if (tourAvailability) {
            this.deserialize(tourAvailability);
        }
    }

    startTime: number = null;
    endTime: number = null;
    endDayOfWeek: number = null;
    startDayOfWeek: number = null;
    id: number = null;
    guid: string = Guid.newGuid();
}

export class PendingCaseReport extends EntityBase {
    id: number = null;
    caseId: string = null;
    natureOfCallValues: Array<string> = new Array<string>();
    callLoc: string = null;
    author: number = null;
    authorName: string = null;

    constructor(tour?: PendingCaseReport) {
        super();
        if (tour) {
            this.deserialize(tour);
        }
    }
}

export class GuardTour extends EntityBase {
    id: number = null;
    title: string = null;
    clientName: string = null;
    startTimeLocal: number = null;
    endTimeLocal: number = null;
    timeZoneLocal: string = null;
    stopsCompleted: number = null;
    totalStops: number = null;
    officerNames: Array<string> = new Array<string>();

    constructor(guardTour?: GuardTour) {
        super();
        if (guardTour) {
            this.deserialize(guardTour);
        }
    }
}

export class GuardTourStop extends EntityBase {
    constructor(guardTourStop?: GuardTourStop) {
        super();
        if (guardTourStop) {
            this.deserialize(guardTourStop);

            this.tourStopChecklist = this.tourStopChecklist.map(ta => new TourStopChecklistItem(ta));
            this.tourStopTaskList = this.tourStopTaskList.map(ta => new GuardTourStopTask(ta));
            this.tourStopIssues = this.tourStopIssues.map(ta => new TourStopIssue(ta));
        }
    }

    id: number = null;
    title: string = "";
    npsdClientName: string = "";
    npsdClientSiteNames: string = "";
    location: string = "";
    instructions: string = "";

    tourStopChecklist: Array<TourStopChecklistItem> = new Array<TourStopChecklistItem>();
    tourStopTaskList: Array<GuardTourStopTask> = new Array<GuardTourStopTask>();
    taskCompletionExemptionList: any[] = [];

    tourStopIssues: Array<TourStopIssue> = new Array<TourStopIssue>();
    claimedByIdList: Array<number> = new Array<number>();

    areOfficerCommentsRequired: number = OfficerCommentsRequired.REQUIRED;

    areOfficerAttachmentsEnabled: boolean = OfficerAttachmentsEnabled.DISABLED;

    newTourStopIssue: TourStopIssue = new TourStopIssue();
    areIssuesEnabled: boolean = null;

    activeStartDateTime: string = null;
    activeEndDateTime: string = null;
    officerComments: string = "";
    latitude: number = null;
    longitude: number = null;
    numTimesToComplete: number = null;
    completionList: Array<GuardTourCompletion> = new Array<GuardTourCompletion>();

    resizedImageList: Array<Attachment> = new Array<Attachment>(); //Receive
    attachmentList: Array<Attachment> = new Array<Attachment>(); //Receive
    newAttachmentInfoList: Array<AttachmentInfo> = new Array<AttachmentInfo>(); //Send

    geofence: Array<{ lat: number; lng: number }> = null;

    //This is the tour stop ID, not the guard tour stop ID. It's used by the front end for realtime updates.
    tourStopId: number = null;
    showHistory: boolean = false;
    showGeoFence: boolean = false;
    AddEditIssue: boolean = false;
    showTourStop: boolean = false;
    isMobile: boolean = App.isMobile();
}

export class GuardTourStopTaskExemption extends EntityBase {
    constructor(guardTourStopTaskExemption?: GuardTourStopTaskExemption) {
        super();
        if (guardTourStopTaskExemption) {
            this.deserialize(guardTourStopTaskExemption);
        }
    }
    name: string = null;
    description: string = null;
}

export class GuardTourStopTaskTimeSensitive extends EntityBase {
    constructor(guardTourStopTaskTimeSensitive?: GuardTourStopTaskTimeSensitive) {
        super();
        if (guardTourStopTaskTimeSensitive) {
            this.deserialize(guardTourStopTaskTimeSensitive);
        }
    }
    startDateTime: Date = null;
    endDateTime: Date = null;
}

export class GuardTourStopTask extends EntityBase {
    constructor(guardTourStopTask?: GuardTourStopTask) {
        super();
        if (guardTourStopTask) {
            this.deserialize(guardTourStopTask);
            this.isChecked = hasValue(this.completedAt)
        }
    }
    name: string = null;
    description: string = null;
    listIdx: number = null;
    completedAt: Date = null;
    tourExemption: GuardTourStopTaskExemption = new GuardTourStopTaskExemption();
    tourStopTaskId: number = null;
    timeSensitive: GuardTourStopTaskTimeSensitive = new GuardTourStopTaskTimeSensitive();
    taskCompletionExemptionIds: number[] = [];
    isTaskCompletionExemption: boolean = false;

    exceptionId: number = null; //FE-only.
    isChecked: boolean = false; //FE-only.
}

export class TourStopChecklistItem extends EntityBase {
    constructor(tourStopCheckListItem?: TourStopChecklistItem) {
        super();
        if (tourStopCheckListItem) {
            this.deserialize(tourStopCheckListItem);
        }
    }

    id: number = null;
    type: string = "";
    instructions: string = "";
    completedAt: Date = null;
}

export class TourStopIssue extends EntityBase {
    constructor(tourStopIssue?: TourStopIssue) {
        super();
        if (tourStopIssue) {
            this.deserialize(tourStopIssue);
        }

        this.tempid = Guid.newGuid();
        this.isResolved = App.IsNOU(this.resolvedAt) === false && App.IsNOU(this.resolvedByName) === false;
    }

    id: number = null; //Send and Receive
    title: string = null; //Send initially and Receive
    description: string = null; //Send initially and Receive
    raisedAt: string = null; //Receive
    raisedByName: string = null; //Receive
    resolvedAt: string = null; //Receive
    resolvedByName: string = null; //Receive

    DisplayText: string = this.description +
        (this.raisedAt !== null && this.raisedAt !== undefined) ? moment(this.raisedAt).format(DATETIME_FORMAT_DISPLAY_LOCAL_MOMENT) : "" +
        this.raisedByName;

    isResolved: boolean = false;

    resizedImageList: Array<AttachmentWithGuid> = new Array<AttachmentWithGuid>(); //Receive
    newAttachmentInfoList: Array<AttachmentInfoWithGuid> = new Array<AttachmentInfoWithGuid>(); //Send

    tempid: string = null;
}

export class GuardTourCompletion extends EntityBase {
    constructor(tourStopIssue?: TourStopIssue) {
        super();
        if (tourStopIssue) {
            this.deserialize(tourStopIssue);
        }
    }

    id: number = null;
    completedAt: Date = null;//"2020-08-17T19:08:03.106Z"
    completedByName: string = null;// "semyon starobin"
    latitude: string = null;// "33.0054667"
    longitude: string = null;//"-96.8826651"
    officerComments: string = null;//"asdfsdf"
}

export class UpdateOfficerComments extends EntityBase {
    constructor(updateOfficerComments?: UpdateOfficerComments) {
        super();
        if (updateOfficerComments) {
            this.deserialize(updateOfficerComments);
        }
    }
    id: number = null;
    officerComments: string = null;
    guardTourStopId: number = null; //To go back to guard tour stop screen.
}


// ============================================================================
// tour-stop.ts
// ============================================================================

export class TourStop extends EntityBase {
    constructor(tourStop?: TourStop) {
        super();
        if (tourStop) {
            this.deserialize(tourStop);

            this.tourStopTaskList = [];
            if (tourStop.tourStopTaskList) {
                for (let i = 0; i < tourStop.tourStopTaskList.length; i++)
                    this.tourStopTaskList.push(new TourStopTask(tourStop.tourStopTaskList[i]));
            }
        }
    }

    get DaysOfWeek(): Array<WeekDay> {
        var dow = JSON.parse(JSON.stringify(WeekDays));

        //for (var i = 0; i < dow.length; i++) {
        //    dow[i]["TAGroups"] = this.tourStopChecklist.tourAvailabilityList.filter(n => n.startDayOfWeek === dow[i].dayOfWeek);
        //}

        return dow;
    }
    Clone(): TourStop {
        // Use constructor to properly deep clone tourStopTaskList
        return new TourStop(this);
    }
    SerializeToJson(): string {
        let tourStopCopy: TourStop = this.Clone();
        delete tourStopCopy.geofencePolygon;
        delete tourStopCopy.map;
        return JSON.stringify(tourStopCopy);
    }

    id: number = null;//, ID of tour stop
    title: string = null;
    client: TourClient = new TourClient(null);

    location: string = null;
    locationLatitude: number = null;
    locationLongitude: number = null;
    customLocationId: boolean = null;
    instructions: string = null;
    startDateTime: Date = null;
    endDateTime: Date = null;
    pauseWindowStartDateTime: Date = null;
    pauseWindowEndDateTime: Date = null;
    isEnabled: boolean = true;
    isChecklistEnabled: boolean = false;
    areIssuesEnabled: boolean = false;
    areOfficerCommentsRequired: number = OfficerCommentsRequired.REQUIRED;
    isGeofenceEnabled: boolean = false;
    timeZoneId: string = Intl.DateTimeFormat().resolvedOptions().timeZone;
    areOfficerAttachmentsEnabled = OfficerAttachmentsEnabled.ENABLED;
    enabledTourStopDaysType = EnabledTourStopDaysType.ALL_DAYS
    isEnabledOnSaturdays = true;
    isEnabledOnSundays = true;
    enabledDaysOfWeek = 127;
    tourStopChecklist: Array<TourStopCheck> = [];
    tourStopTaskList: Array<TourStopTask> = [];
    geofencePolygon: google.maps.Polygon = null;
    geofence: Array<{ lat: number, lng: number }> = null;
    map: google.maps.Map;

    numTimesToComplete: number = null;

    // 24h end-of-stop reminder. The recipient list is company-wide and lives on Company —
    // not on TourStop — but the server inlines it on TourStopGet for convenient display
    // (e.g., showing "the reminder for this stop will go to X"). Read-only on this form.
    // lastReminderSentAt is per-stop and populated by the server after the reminder fires.
    reminderEmail: string = null;
    lastReminderSentAt: string = null;
}

export class TourClient extends EntityBase {
    constructor(tourClient?: TourClient) {
        super();
        if (tourClient) {
            this.deserialize(tourClient);
        }
    }

    id: number = null;//, selected client id
    name: string = null;//, name of client - GET ONLY
    allSites: Array<CallCardClientGroupSite> = null;
    sites: Array<number> = new Array<number>();
}

export class TourStopCheck extends EntityBase {
    constructor(tourStopCheck?: TourStopCheck) {
        super();
        if (tourStopCheck) {
            this.deserialize(tourStopCheck);
        }
    }

    type: string = null;
    instructions: string = null;
    listIdx: number = null;//0 - based index
}

export class TourStopTask extends EntityBase {
    constructor(tourStopTask?: TourStopTask) {
        super();
        if (tourStopTask) {
            this.deserialize(tourStopTask);

            this.timeSensitiveList = [];
            // Copy time sensitive items if they exist
            if (tourStopTask.timeSensitiveList) {
                for (let i = 0; i < tourStopTask.timeSensitiveList.length; i++)
                    this.timeSensitiveList.push(new SensitiveTask(tourStopTask.timeSensitiveList[i]));
            }

            this.isChecked = this.completedAt !== null;
        }
    }

    tourStopTaskId: number = null;
    taskId: number = null;
    name: string = null;
    description: string = null;
    listIdx: number = null;//0 - based index.
    isChecked: boolean = null;
    completedAt: Date = null;
    tourExemption: Array<TourExemption> = [];
    timeSensitiveList: Array<SensitiveTask> = [];

    timeSensitive: SensitiveTask = null;

    numAssociatedTourStops = null;

    // using this id just in front end because you can have duplicate tasks with the same listidx so I need something to distinguish them in the grid
    uniqueId: string = Guid.newGuid();
    exceptionId: number = null;

    get TimeSensitiveList(): Array<SensitiveTask> {
        return this.timeSensitiveList;
    }

    get DaysOfWeek(): Array<WeekDay> {
        const dow = JSON.parse(JSON.stringify(WeekDays));

        for (let i = 0; i < dow.length; i++) {
            dow[i]["TAGroups"] = this.timeSensitiveList.filter(n => n.startDayOfWeek === dow[i].dayOfWeek);
        }

        return dow;
    }
}

export class SensitiveTask extends EntityBase {
    constructor(sensitiveTask?: SensitiveTask) {
        super();
        if (sensitiveTask) {
            this.deserialize(sensitiveTask);
        }
    }

    startTime: number = null;// - int(number of milliseconds past midnight)
    endTime: number = null;// - int(number of milliseconds past midnight)
    startDayOfWeek: number = null;// - int(Sunday = 1, Monday = 2, ..., Saturday = 7)
    endDayOfWeek: number = null;// - int(Sunday = 1, Monday = 2, ..., Saturday = 7)

    guid: string = Guid.newGuid();

    // to be used only on guard tours
    endDateTime: Date = null;// "2020-08-13T21:49:00.000Z"
    startDateTime: Date = null;// "2020-08-13T16:49:00.000Z"
}


// ============================================================================
// call-cards.ts
// ============================================================================

// Phase 7 — CallCardScreen React component (src/components/screens/CallCardScreen.tsx)
// replaces the Vue instance. The React component orchestrates all sub-components:
// CallCardDetailsForm, CallCardComments, CallCardStatusBanner, CallCardDisposition,
// CallCardPersonGrid, CallCardVehicleGrid, CallCardAttachmentsGrid, CallCardAuditLogGrid,
// CallCardHistoryGrid, CallCardCitationsGrid, OfficersAssigned, MdtBottomBar, DisabledFieldToast.
// App.callCardController provides typed access to the React CallCardScreen's state and methods.

export let realtimeUpdateCallCardScreenLoadedTimeout = null;
Object.defineProperty(window, 'realtimeUpdateCallCardScreenLoadedTimeout', {
  get: () => realtimeUpdateCallCardScreenLoadedTimeout,
  set: (v) => { realtimeUpdateCallCardScreenLoadedTimeout = v; },
  configurable: true,
});

export enum CallCardInProgressStatus {
    active = 1,
    pending = 2,
    closed = 3
}

export enum MDTInProgressStatus {
    open = 1,
    active = 2,
    pending = 3,
    closed = 4
}

export enum CallCardStatus {
    CASE_OPEN = 1,
    CASE_CLOSED = 2
}

export enum CCAction {
    CLOSE = 1,
    UPDATE = 2,
    ADD = 3,
    RECLOSE = 4
}

export class CallCardClientGroupSite implements IEquals {
    id: number = null;
    siteName: string = null;

    constructor(result: any) {
        if (result !== undefined && result !== null) {
            for (let k in result) {
                if (this[k] !== undefined) {
                    this[k] = result[k];
                }
            }
        }
    }

    equals(other: CallCardClientGroupSite) {
        if (other === null) {
            return false;
        }
        return ((this.id === other.id) && (this.siteName === other.siteName));
    }
}

export class CallCardClientGroup {
    id: number = null;
    name: string = null;
    sites: Array<number> = null;
    allSites: Array<CallCardClientGroupSite> = null;

    constructor(result: any) {
        if (result !== undefined && result !== null) {
            for (let k in result) {
                if (this[k] !== undefined) {
                    const val = result[k];
                    if (k === "sites") {
                        this[k] = val ? val.slice() : null;
                    } else if (k === "allSites") {
                        const allSitesArr: Array<CallCardClientGroupSite> = [];
                        for (let site of (result[k] || [])) {
                            allSitesArr.push(new CallCardClientGroupSite({ id: site.id, siteName: site.siteName }));
                        }
                        this[k] = allSitesArr;
                    } else {
                        this[k] = val;
                    }
                }
            }
        }
    }

    clone() {
        return new CallCardClientGroup(this);
    }

    public static updateCallCardClientGroupChanges(latestCallCard: CallCard, originalCallCard: CallCard, currentCallCard: CallCard) {
        const latestCCG = latestCallCard.client;
        const originalCCG = originalCallCard.client;
        const currentCCG = currentCallCard.client;

        if (latestCCG === null && originalCCG === null) {
            return false;
        }
        if (latestCCG === null) {
            originalCallCard.client = null;
            currentCallCard.client = null;

            return true;
        }
        if ((originalCCG === null) || (latestCCG.id !== originalCCG.id) || (latestCCG.name !== originalCCG.name)) {
            originalCallCard.client = latestCCG.clone();
            currentCallCard.client = latestCCG.clone();

            return true;
        }
        if (!arraysEqual(latestCCG.sites, originalCCG.sites)) {
            originalCallCard.client = latestCCG.clone();
            currentCallCard.client = latestCCG.clone();

            return true;
        }
        if (!arraysEqualsWithIEquals(latestCCG.allSites, originalCCG.allSites)) {
            originalCallCard.client = latestCCG.clone();
            currentCallCard.client = latestCCG.clone();

            return true;
        }

        return false;
    }
}

export class CallCard {
    id: number = null;
    prevCallCardId: number = null;
    createdAt: Date = null;
    eventId: string = "";
    relatedCardsId: number = null;
    company: number = null;
    callDateTime: Date = null;
    callLocName: string = "";
    callLocAddress: string = "";
    callLocAddress2: string = "";
    callLocCity: string = "";
    callLocState: string = "";
    callLocZip: string = "";
    callLocCountry: string = "";
    callLocFormattedAddress: string = "";
    latitude: number = null;
    longitude: number = null;
    // AddressVerificationStatus enum name from the backend:
    // 'HIGH' | 'LOW' (approximate pin) | 'AREA' (address not found; pin is the service-area centre)
    // | 'MANUAL' (dragged pin) | 'OFFICER_ON_SCENE' (confirmed from an officer's GPS) | 'LEGACY'.
    addressVerificationStatus: string = null;
    // GPS accuracy (meters) recorded by an on-scene confirm; null unless confirmed.
    locationPinAccuracyM: number = null;
    // Person id stamped by the last verification; the on-scene confirmer when OFFICER_ON_SCENE.
    addressVerifiedBy: number = null;
    // "First Last" of the on-scene confirmer; sent with OFFICER_ON_SCENE only.
    addressVerifiedByName: string = null;
    // When the last verification was stamped (ISO string from the server).
    addressVerifiedAt: string = null;
    // Learned-address row the pin came from; sent on save so the server can keep the link.
    learnedAddressId: number = null;
    // { learnedAddressId, capturedAt, capturedByName } while that learned row is still in use, else null.
    learnedLocation: { learnedAddressId: number; capturedAt: string; capturedByName: string } = null;
    customLocationId: boolean = null;
    callerName: string = "";
    callerPhone: string = "";
    callerLocation: string = "";
    callDisposition: number = null;
    callDispositionValue: string = "";
    dispositionNotes: string = "";
    //callNotes: string = "";
    primaryOfficer: number = null;
    primaryOfficerName: string = "";
    primaryDispatched: Date = null;
    whenPrimaryDispatchedChanged: Date = null;
    primaryEnroute: Date = null;
    whenPrimaryEnrouteChanged: Date = null;
    primaryOnScene: Date = null;
    whenPrimaryOnSceneChanged: Date = null;
    primaryCleared: Date = null;
    whenPrimaryClearedChanged: Date = null;
    ccStatus: number = null;
    author: number = null;
    priority: number = 5;

    primaryStartingMileage: number = null;
    primaryEndingMileage: number = null;

    natureOfCall: Array<number> = null;
    natureOfCallValues: Array<string> = null;
    backupUnits: Array<Officer> = [];
    queuedUnits: Array<Officer> = [];

    people: Array<CCPerson> = [];
    vehicles: Array<CCVehicle> = [];

    attachmentList: Array<Attachment> = new Array<Attachment>(); //Receive
    attachmentInfoList: Array<AttachmentInfo> = new Array<AttachmentInfo>();

    callCommentsToAttach: Array<number> = [];

    client: CallCardClientGroup = new CallCardClientGroup('');

    /**
     * Citation count for this call card (frontend-only extension).
     * Not part of the API spec - populated from citation search results.
     * Used to display badge count on Citations tab.
     */
    citationCount: number = null;

    //Set to true when call is closed, and we are updating/reclosing the call.
    updateAndReclose: boolean = false;

    constructor(result: any, moduleType: ModuleType, loadCC: boolean, officersList: any = null) {
        if (result !== undefined && result !== null) {
            for (let k in result) {
                if (k === "client" || k === "backupUnits" || k === "people" || k === "vehicles" || k === "queuedUnits") {
                    continue;
                }
                if (this[k] !== undefined) {
                    if (CallCard.isDateField(k)) {
                        this[k] = getNullableDateClone(result[k]);
                    } else {
                        this[k] = result[k];
                    }
                }
            }
            // The GET carries the link inside learnedLocation; keep it so ordinary saves round-trip it.
            if (!hasValue(this.learnedAddressId) && hasValue(this.learnedLocation?.learnedAddressId)) {
                this.learnedAddressId = this.learnedLocation.learnedAddressId;
            }

            if (result.backupUnits !== null) {
                for (let officer of result.backupUnits) {
                    this.backupUnits.push(
                        new Officer(officer.id, officer.officer, officer.officerName, officer.dispatched, officer.whenDispatchedChanged,
                            officer.enroute, officer.whenEnrouteChanged, officer.onScene, officer.whenOnSceneChanged,
                            officer.cleared, officer.whenClearedChanged, officer.isPrimary, officer.startingMileage, officer.endingMileage)
                    );
                }
            }

            if (result.queuedUnits !== null) {
                for (let officer of result.queuedUnits) {
                    this.queuedUnits.push(
                        new Officer(officer.id, officer.officer, officer.officerName, officer.dispatched, officer.whenDispatchedChanged,
                            officer.enroute, officer.whenEnrouteChanged, officer.onScene, officer.whenOnSceneChanged,
                            officer.cleared, officer.whenClearedChanged, officer.isPrimary, officer.startingMileage, officer.endingMileage, officer.eventId, officer.callCardId,
                            officer.isQueued)
                    );
                }
            }

            if (result.people !== null) {
                for (let person of result.people) {
                    this.people.push(
                        new CCPerson({
                            id: person.id, firstName: person.firstName, lastName: person.lastName, dob: person.dob,
                            license: person.license, notes: person.notes, npsdPerson: person.npsdPerson
                        })
                    );
                }
            }

            if (result.vehicles !== null) {
                for (let vehicle of result.vehicles) {
                    this.vehicles.push(
                        new CCVehicle({
                            id: vehicle.id, make: vehicle.make, model: vehicle.model, year: vehicle.year,
                            color: vehicle.color, plateState: vehicle.plateState, plateNumber: vehicle.plateNumber,
                            vehicleType: vehicle.vehicleType, notes: vehicle.notes, npsdVehicle: vehicle.npsdVehicle
                        })
                    );
                }
            }

            if (result.client !== null) {
                this.client = new CallCardClientGroup(result.client);
            }

            this.attachmentInfoList = [];
            for (let i = 0; i < this.attachmentList.length; i++) {
                const attachment = new AttachmentInfo();
                attachment.id = this.attachmentList[i].id;
                this.attachmentInfoList.push(attachment);
            }
        }

        if (loadCC) {
            App.currentCC = this; //only set currentCC with loadCC=true since other CallCard objects can be created (e.g. in realtime)
            App.currentCCCntr = new CallCardController();
            if (officersList) {
                App.currentCCCntr.cachedOfficerList = officersList;
            }
            App.currentCCCntr.callComments = [];
            if (hasValue(this.id)) {
                api.listCallComments(this.id, (result) => {
                    if (!App.currentCCCntr) {
                        //This can happen if the user presses the back button right after loading a call card.
                        return;
                    }
                    //concatenate the entries to avoid race conditions
                    let resultCallComments: Array<CallComment> = [];
                    for (const entry of result.entries) {
                        resultCallComments.push(new CallComment(entry));
                    }
                    App.currentCCCntr.callComments = resultCallComments.concat(App.currentCCCntr.callComments);
                    sortAndRemoveDuplicates(App.currentCCCntr.callComments, App.currentCCCntr.callCommentCompare);
                }, (result) => {
                    //error
                });
            }
            App.currentCCCntr.moduleType = moduleType;
            App.currentCCCntr.showCard();

            if (hasValue(this.latitude) && hasValue(this.longitude)) {
                getPatrolZoneNames(this.latitude, this.longitude, result => {
                    if (App.callCardController) {
                        App.callCardController!.patrolZoneNames = result;
                    }
                })
            }

            //Load Call Alert
            if (hasStringValue(this.callLocFormattedAddress)) {
                const data = { locFormattedAddress: this.callLocFormattedAddress };
                api.getCallAlert(data, (callAlert) => {
                    if (App.callCardController && hasStringValue(callAlert.message)) {
                        App.callCardController!.callAlert = callAlert;
                    }
                }, (err) => {
                    //Only show this error if user is logged in.
                    if (getAuthObject()) {
                        App.showPopupNotification("Error getting call alert.", 'error');
                    }
                });
            }

            //Preload Custom Locations list to optimize Calls for Service save.
            getCustomLocationListPromise();
        }
    }

    public static isPrimaryOfficerField(name: string) {
        if (name === "primaryOfficer" ||
            name === "primaryOfficerName" ||
            name === "primaryDispatched" ||
            name === "primaryEnroute" ||
            name === "primaryOnScene" ||
            name === "primaryCleared") {
            return true;
        }
        return false;
    }

    public static isDateField(name: any) {
        if (name === "createdAt" ||
            name === "callDateTime" ||
            name === "primaryDispatched" ||
            name === "primaryEnroute" ||
            name === "primaryOnScene" ||
            name === "primaryCleared" ||
            name === "whenPrimaryDispatchedChanged" ||
            name === "whenPrimaryEnrouteChanged" ||
            name === "whenPrimaryOnSceneChanged" ||
            name === "whenPrimaryClearedChanged" ||
            name === "dispatched" ||
            name === "enroute" ||
            name === "onScene" ||
            name === "cleared" ||
            name === "whenDispatchedChanged" ||
            name === "whenEnrouteChanged" ||
            name === "whenOnSceneChanged" ||
            name === "whenClearedChanged") {
            return true;
        }
        else
            return false;
    }
}

export class CallComment {
    constructor(result: any) {
        if (result !== undefined && result !== null) {
            for (let k in result) {
                if (this[k] !== undefined && result[k] !== undefined) {
                    if (k === 'dateCreated') {
                        this[k] = getNullableDateClone(result[k]);
                    } else {
                        this[k] = result[k];
                    }
                }
            }
        }
    }

    id: number = null;
    dateCreated: Date = null;
    creatorName: string = null;
    entry: string = null;
}

export class CallCardController {
    private ccNOC: any;
    private ccCurrentAction: CCAction;

    public callComments: Array<CallComment> = [];

    public newCard: boolean = (App.currentCC.id === undefined || App.currentCC.id === null || App.currentCC.id === 0);
    public moduleType: ModuleType = null;

    public cachedOfficerList: any = null;

    public showCard() {
        this.mountScreen();
        // React rendering is async — the useEffect that creates App.callCardController
        // runs after paint. Poll until the shim is available before calling setControls.
        const waitForShim = setInterval(() => {
            if (App.callCardController) {
                clearInterval(waitForShim);
                this.setControls();
            }
        }, 10);
    }

    //compare (for sorting) by dateCreated first, then by id
    public callCommentCompare(a: CallComment, b: CallComment): number {
        let timeCompare = a.dateCreated.getTime() - b.dateCreated.getTime();
        if (timeCompare === 0) {
            let idCompare = a.id - b.id;
            return idCompare;
        } else {
            return timeCompare;
        }
    }

    private setControls() {
        // Ensure callDateTime is set (Vue datetime picker will handle the display)
        if (App.currentCC.callDateTime === null) {
            App.currentCC.callDateTime = new Date();
        }

        // Helper functions defined here will be added as Vue methods for accessibility

        // Load dropdown data for Vue components
        const initialClientId = ((App.currentCC.client !== null) ? App.currentCC.client.id : null);
        const initialClientAllSites = ((App.currentCC.client !== null && App.currentCC.client.allSites !== null)
            ? App.currentCC.client.allSites : []);

        // Store initial values in Vue data for later reference
        App.callCardController!.initialClientId = initialClientId;
        App.callCardController!.initialClientAllSites = initialClientAllSites;

        // Load Nature of Call options
        api.listNatureOfCall(result => {
            if (!App.currentCC || !App.callCardController) return;
            const data = mergeCurrentNatureOfCallIntoNatureOfCallList(
                App.currentCC.natureOfCall,
                App.currentCC.natureOfCallValues,
                result.natureOfCallList
            );
            App.callCardController!.natureOfCallOptions = data;
            // Update SOP link with initial data
            const selectedItems = data.filter((item: any) =>
                App.currentCC.natureOfCall && (App.currentCC.natureOfCall as any[]).indexOf(item.code) !== -1
            );
            App.callCardController!.fnUpdateCallCardNatureOfCallSopLink(selectedItems);
        }, errorResult => {
            App.showPopupNotification("Error getting nature of call data.", 'error');
        });

        // Load Client options
        api.listClientGroup(result => {
            if (!App.callCardController) return;
            const list = result.npsdClientList.map((item: any) => {
                const company = result.companyList.find((n: any) => n.id === item.companyId);
                return {
                    ...item,
                    name: item.name + " - " + (company ? company.name : '')
                };
            });
            // Sort by name
            list.sort((a: any, b: any) => a.name.localeCompare(b.name));
            App.callCardController!.clientOptions = list;

            // Update client link with initial selection
            if (initialClientId) {
                const selectedClient = list.find((c: any) => c.id === initialClientId);
                if (selectedClient) {
                    App.callCardController!.fnUpdateCallCardClientLink(selectedClient.id, selectedClient.name, selectedClient.companyId);
                }
            }
        });

        // Load Site options (based on initial client or all sites)
        if (initialClientId && initialClientAllSites.length > 0) {
            App.callCardController!.siteOptions = initialClientAllSites;
        } else if (initialClientId) {
            api.listClientGroupSite(initialClientId, (result: any[]) => {
                if (!App.callCardController) return;
                App.callCardController!.siteOptions = result;
            }, () => {});
        } else {
            api.listAllClientGroupSite((result: any[]) => {
                if (!App.callCardController) return;
                App.callCardController!.siteOptions = result;
            }, () => {});
        }

        // Initialize officers for grid component
        let officers = getOfficerListFromCallCard(App.currentCC);
        App.callCardController!.officers = convertOfficersForGrid(officers);
        App.callCardController!.availablePeople = this.cachedOfficerList || [];

        // Initialize vehicles and people grid component
        App.callCardController!.people = convertPeopleForGrid(App.currentCC.people);
        App.callCardController!.vehicles = convertVehiclesForGrid(App.currentCC.vehicles);

        
            //{
            //    hidden: true, field: "isQueued", template(e) {
            //        const queued = App.currentCCCntr.cachedOfficerList?.find(n => n.id === e.officer && n.eventId !== null && n.eventId !== App.currentCC.eventId);

            //        return queued !== undefined;
            //    }
            //},
            
        api.getAvailableCADOfficers(App.currentCC.id, result => {
            if (!App.currentCCCntr) {
                return; // User navigated to another screen
            }

            processCallCardAvailableOfficers(result);
            App.currentCCCntr.cachedOfficerList = result.officerList;
            if (App.callCardController) {
                App.callCardController.availablePeople = result.officerList;
            }
        });
        
        // Load Disposition options for React component
        api.listCallDispositions(result => {
            if (!App.currentCC || !App.callCardController) return;
            const data = mergeCurrentCallDispositionIntoCallDispositionList(
                App.currentCC.callDisposition,
                App.currentCC.callDispositionValue,
                result.callDispositionList
            );
            data.unshift({ dispositionCode: -1, dispositionValue: 'Select Disposition', companyId: -1, listIdx: -1 });
            App.callCardController!.dispositionOptions = data;
        }, errorResult => {
            App.showPopupNotification("Error getting call disposition data.", 'error');
        });

        if (App.currentCC.ccStatus === CallCardStatus.CASE_CLOSED) {
            if (App.currentCCCntr.moduleType === ModuleType.cad) {
                this.setCADCallCardEnabled(false);
            }
        } else {
            App.callCardController!.callCardNotClosed = true;
        }

        if (App.currentCCCntr.moduleType === ModuleType.mdt) {
            if (this.isSelfInitiatedCall()) {
                this.setMDTCallCardEnabled(true);
                App.callCardController!.isEditMode = true;
            } else {
                this.setMDTCallCardEnabled(false);
            }

            //disable or hide button on bottom navbar depending on whether or not the user is the primary officer, a backup unit officer, or not an officer.
            let userId = getCurrentUserId().toString();
            let isOfficer = false;
            if (App.currentCC.primaryOfficer !== null && App.currentCC.primaryOfficer !== undefined && App.currentCC.primaryOfficer.toString() === userId) {
                isOfficer = true;
            }
            for (var backupUnit of App.currentCC.backupUnits)
                if (backupUnit.officer.toString() === userId)
                    isOfficer = true;

            if (isOfficer) {
                App.callCardController!.isOfficerOnCallCard = true;
            }
        }

        this.pageLoaded();
    }

    private pageLoaded() {
        App.callCardController!.pageReady = true;
    }

    private mountScreen() {
        const container = document.getElementById('divCallCardMain');
        if (container) {
            // Clear any existing content before mounting React
            container.innerHTML = '';

            (window as any).OrnaReact.renderComponent(
                (window as any).CallCardScreenReact,
                {
                    CC: App.currentCC,
                    CCCntr: App.currentCCCntr,
                    moduleType: this.moduleType,
                },
                container
            );
        }
    }

    public closeCC(callbackAfterClose: Function = null) {
        App.currentCCCntr.ccCurrentAction = CCAction.CLOSE;
        App.currentCCCntr.saveOrUpdateOrCloseCallCard(callbackAfterClose);
    }

    // update/close/create call cards
    public saveOrUpdateOrCloseCallCard(callbackAfterSaveOrCloseOrUpdate: Function = null) {
        const addressValidationErrorMsg: string = "Error validating call location. Please re-enter the call location address/intersection.";

        // Force save any pending edits in sub-components before proceeding.
        // This ensures that if a user clicks Update/Close while editing a field,
        // the edit is committed before the save operation begins.
        App.callCardController!.forceSaveOfficerEdits();

        // Capture the action now, before the setTimeout. If App.currentCCCntr is
        // replaced during the 150ms delay (e.g. page navigation or realtime reload),
        // reading from the global ref inside the callback would see an uninitialised
        // ccCurrentAction on the *new* controller and fall into the error branch.
        const capturedAction: CCAction = this.ccCurrentAction;

        // Give React time to process date picker closes and value commits
        // 150ms delay to allow date pickers to close and commit values through async state updates
        setTimeout(() => {
            this.validateCard(function (e) {
                // Get officers from React component
                let gridOfficers = App.callCardController!.officers;
                for (let vueOfficer of gridOfficers) {
                    if (!vueOfficer.officerId) {
                        App.showPopupNotification(`Select ${getOfficerLabel().toLowerCase()} name.`, "error")
                        return;
                    }
                }

                // Ensure vehicles data is synced and formatted
                // Trigger a final sync from React to App.currentCC with proper formatting
                const vueVehicles = App.callCardController!.vehicles;
                App.currentCC.vehicles = vueVehicles
                    .filter(v =>
                        hasValue(v.make) ||
                        hasValue(v.model) ||
                        hasValue(v.year) ||
                        hasValue(v.color) ||
                        hasValue(v.plateState) ||
                        hasValue(v.plateNumber) ||
                        hasValue(v.vehicleType)
                    )
                    .map(v => {
                        const vehicle = deepCopyProperties(v);

                        // Remove uuid (grid-specific field)
                        delete vehicle.uuid;

                        // Convert vehicleType object to just the code for API
                        if (hasValue(vehicle.vehicleType) && typeof vehicle.vehicleType === 'object') {
                            if (hasValue(vehicle.vehicleType.code)) {
                                vehicle.vehicleType = vehicle.vehicleType.code;
                            } else {
                                vehicle.vehicleType = null;
                            }
                        }

                        return vehicle;
                    });

                // Ensure people data is synced and formatted
                const vuePeople = App.callCardController!.people;
                App.currentCC.people = vuePeople
                    .filter(p =>
                        hasValue(p.firstName) ||
                        hasValue(p.lastName) ||
                        hasValue(p.dob) ||
                        hasValue(p.license) ||
                        hasValue(p.notes)
                    )
                    .map(p => {
                        const person = deepCopyProperties(p);

                        // Remove uuid (grid-specific field)
                        delete person.uuid;

                        return person;
                    });

                // Nature of Call is already updated via React state

                // Rebuild backup and queued units
                App.currentCC.backupUnits = [];
                App.currentCC.queuedUnits = [];

                let primaryOfficer = null;

                for (let vueOfficer of gridOfficers) {
                    const officer = new Officer(
                        vueOfficer.id,
                        vueOfficer.officerId,
                        vueOfficer.name,
                        vueOfficer.dispatched,
                        null,
                        vueOfficer.enroute,
                        null,
                        vueOfficer.onScene,
                        null,
                        vueOfficer.cleared,
                        null,
                        vueOfficer.isPrimary,
                        vueOfficer.startingMileage || null,
                        vueOfficer.endingMileage || null,
                        vueOfficer.eventId,
                        vueOfficer.callCardId,
                        vueOfficer.isQueued
                    );

                    // Check isPrimary FIRST - primary officers are not added to arrays
                    if (vueOfficer.isPrimary) {
                        primaryOfficer = officer;
                    } else if (vueOfficer.isQueued || vueOfficer.isBusy) {
                        App.currentCC.queuedUnits.push(officer);
                    } else {
                        App.currentCC.backupUnits.push(officer);
                    }
                }

                // Update primary officer on CallCard
                if (primaryOfficer) {
                    App.currentCC.primaryOfficer = primaryOfficer.officer;
                    App.currentCC.primaryOfficerName = primaryOfficer.officerName;
                    App.currentCC.primaryDispatched = primaryOfficer.dispatched;
                    App.currentCC.primaryEnroute = primaryOfficer.enroute;
                    App.currentCC.primaryOnScene = primaryOfficer.onScene;
                    App.currentCC.primaryCleared = primaryOfficer.cleared;
                    App.currentCC.primaryStartingMileage = primaryOfficer.startingMileage;
                    App.currentCC.primaryEndingMileage = primaryOfficer.endingMileage;
                } else {
                    // Clear primary if no primary officer
                    App.currentCC.primaryOfficer = null;
                    App.currentCC.primaryOfficerName = null;
                    App.currentCC.primaryDispatched = null;
                    App.currentCC.primaryEnroute = null;
                    App.currentCC.primaryOnScene = null;
                    App.currentCC.primaryCleared = null;
                    App.currentCC.primaryStartingMileage = null;
                    App.currentCC.primaryEndingMileage = null;
                }

                // Check if current user is on call card and if they are cleared
                let isCurrentOfficerOnCallCard: boolean = false;
                let isCurrentOfficerCleared: boolean = false;
                const currentOfficerId = getCurrentUserId();

                for (let vueOfficer of gridOfficers) {
                    if (currentOfficerId === vueOfficer.officerId) {
                        isCurrentOfficerOnCallCard = true;
                        if (vueOfficer.cleared) {
                            isCurrentOfficerCleared = true;
                        }
                        break;
                    }
                }

                // Client sites are already updated via React state

                // Disposition is already updated via React state, just validate it
                if (hasNumericValue(App.currentCC.callDisposition) && App.currentCC.callDisposition !== -1) {
                    // callDisposition is already set via React state
                } else {
                    App.currentCC.callDisposition = null;
                }

                if (capturedAction === CCAction.UPDATE) {
                    setCallCardRealtimeEnabled(false);
                    App.callCardController!.saveOrUpdateButtonEnabled = false;
                    const callCardId = App.currentCC.id;
                    api.updateCallCard(App.currentCC, result => {
                        App.pauseItemChangeCheck = true;
                        App.callCardController!.isEditMode = false;
                        if (isCurrentOfficerCleared) {
                            removeMDTActiveCallCard(callCardId);
                        } else if (isCurrentOfficerOnCallCard) {
                            addMDTActiveCallCard(callCardId, false);
                        }
                        if (hasValue(callbackAfterSaveOrCloseOrUpdate)) {
                            callbackAfterSaveOrCloseOrUpdate();
                        } else {
                            window.OrnaReact.navigate.toCallCard(callCardId);
                            if (isCurrentOfficerCleared) {
                                setShowingRecentOfficerAssignedDialogOnPageLoaded(true);
                            }
                        }
                    }, errorResult => {
                        setCallCardRealtimeEnabled(true);
                        App.callCardController!.saveOrUpdateButtonEnabled = true;
                    });
                }
                else if (capturedAction === CCAction.CLOSE || capturedAction === CCAction.RECLOSE) {
                    setCallCardRealtimeEnabled(false);
                    App.callCardController!.saveOrUpdateButtonEnabled = false;
                    const callCardId = App.currentCC.id;
                    api.closeCallCard(App.currentCC, result => {
                        App.pauseItemChangeCheck = true;
                        removeMDTActiveCallCard(callCardId);
                        App.callCardController!.isEditMode = false;

                        if (hasValue(callbackAfterSaveOrCloseOrUpdate)) {
                            callbackAfterSaveOrCloseOrUpdate();
                        } else {
                            if (currentUserHasPermission(AccessAuthorities.ROLE_VIEW_OWN_CLOSED_CALL_CARDS)) {
                                window.OrnaReact.navigate.toCallCard(callCardId);
                                setShowingRecentOfficerAssignedDialogOnPageLoaded(true);
                            } else {
                                goToInProgressScreen();
                            }
                        }
                    }, errorResult => {
                        setCallCardRealtimeEnabled(true);
                        App.callCardController!.saveOrUpdateButtonEnabled = true;
                    });
                }
                else if (capturedAction === CCAction.ADD) {
                    if (App.currentCCCntr.newCard) {
                        setCallCardRealtimeEnabled(false);
                        App.callCardController!.saveOrUpdateButtonEnabled = false;
                        api.saveCallCard(App.currentCC, result => {
                            if (result.id !== undefined && result.id !== null) {
                                App.pauseItemChangeCheck = true;
                                App.currentCC.callCommentsToAttach = [];

                                if (hasValue(callbackAfterSaveOrCloseOrUpdate)) {
                                    callbackAfterSaveOrCloseOrUpdate();
                                } else {
                                    window.OrnaReact.navigate.toCallCard(result.id, 'CAD');
                                }
                            }
                        }, errorResult => {
                            setCallCardRealtimeEnabled(true);
                            App.callCardController!.saveOrUpdateButtonEnabled = true;
                        });
                    }
                }
                else {
                    //This should never happen — ccCurrentAction was not set before
                    //saveOrUpdateOrCloseCallCard was called, or was set to an
                    //unrecognised value.
                    console.error("MdtUpdateOrClose: ccCurrentAction not recognised. capturedAction=" + capturedAction);
                    api.insertNewJSError("MdtUpdateOrClose value not found (action=" + capturedAction + ")", null, null, JSErrorType.UNCAUGHT, null);
                }
            });
        }, 150); // 150ms delay to allow date picker value commits through async state updates
    }

    private validateCard(callback) {
        //If address hasn't changed, reuse latitude and longitude to speed up call.
        if (hasNumericValue(App.currentCCOriginal.latitude) && hasNumericValue(App.currentCCOriginal.longitude) &&
            App.currentCCOriginal.callLocFormattedAddress === App.currentCC.callLocFormattedAddress) {
            callback();
            return;
        }

        validateAddressWithSuggestions({
            address: App.currentCC.callLocFormattedAddress || '',
            errorMessage: addressValidationErrorMsg, isLocationRequired: true, showLoadingScreen: true,
            // Call entry: accept low-confidence results without a preview, marked approximate
            // (on-scene truth Phase A). The dispatcher cannot verify them; the officer can.
            acceptApproximate: true,
            // Previously-saved coords for discrepancy detection on edits (>500m move triggers
            // the dual-pin confirmation modal on pilot users; ignored on legacy Google path).
            previousLat: App.currentCCOriginal?.latitude ?? null,
            previousLng: App.currentCCOriginal?.longitude ?? null,
            // Dispatcher's company id — used for state/country biasing on the proxy call AND
            // for the no-result preview's map-center fallback (company HQ).
            companyId: (window as any).getCurrentCompanyId?.() ?? null,
            // Client selected on the form — tie-break for the trusted client/site lookup when the
            // same address text matches multiple trusted records (prefer the linked client).
            selectedClientId: App.currentCC.client?.id ?? null,
        }).then(locationResultObj => {
            const locationField = document.getElementById('txtValidateableLocation') as HTMLInputElement | null;
            fillInAddressFromSuggestions(locationResultObj, App.currentCC, locationField, DataObjectLocationFields.callForService);

            callback();
        }).catch((err: any) => {
            // The dispatcher declined the Verify Address modal. Any other rejection keeps its
            // existing behavior (the geocode helper already surfaced its own error popup).
            const message: string = (err && err.message) ? String(err.message) : '';
            const keptPrevious = message === 'keep-previous-location';
            const wasCancelled = keptPrevious
                || message === 'preview-cancelled'
                || message === 'drop-pin-cancelled';
            if (!wasCancelled) return;

            // Re-enable the save/update control the same way the save error callbacks do, so the
            // dispatcher can adjust the location and try again.
            setCallCardRealtimeEnabled(true);
            App.callCardController!.saveOrUpdateButtonEnabled = true;

            const locationField = document.getElementById('txtValidateableLocation') as HTMLInputElement | null;

            if (keptPrevious) {
                // "Keep Previous Location" keeps exactly what the control names: the form returns
                // to the call's stored address, so the next Update saves cleanly without re-asking.
                const previousAddress: string = App.currentCCOriginal?.callLocFormattedAddress ?? '';
                if (previousAddress) {
                    if (locationField) locationField.value = previousAddress;
                    if (App.currentCC) App.currentCC.callLocFormattedAddress = previousAddress;
                }
                // The stored pin is kept, so only its stored learned-location link may go with it.
                if (App.currentCC) App.currentCC.learnedAddressId = App.currentCCOriginal?.learnedAddressId ?? null;
                // Same announcement the priority field makes when a NOC changes it for the
                // dispatcher: a brief flash on the field that just changed — no notification.
                if (locationField) {
                    const flashTarget = (locationField.closest('.form-group') ?? locationField) as HTMLElement;
                    flashTarget.classList.remove('field-auto-flash');
                    void flashTarget.offsetWidth; // restart the animation if one is mid-run
                    flashTarget.classList.add('field-auto-flash');
                    setTimeout(() => flashTarget.classList.remove('field-auto-flash'), 2000);
                }
                return;
            }

            // Cancel: leave the typed text in the field for adjustment — the save simply didn't run.
            if (locationField) locationField.focus();
            App.showPopupNotification(hasValue(App.currentCC?.id)
                ? 'Update not saved. Confirm the location to save it.'
                : 'Call not sent. Confirm the location to send it.', 'warning');
        });
    }

    // Form enabled/disabled state is handled by React's isFormDisabled computed property
    private setCallCardEnabled(isEnabled: boolean, moduleType: ModuleType) {}
    private setMDTCallCardEnabled(isEnabled: boolean): void {}
    private setCADCallCardEnabled(isEnabled: boolean): void {}

    private isSelfInitiatedCall(): boolean {
        let isSelfInitiated: boolean = false;
        let selfInitiatedCallCardId: string = localStorage.getItem("SelfInitiatedCallCard");
        //note: localStorage.removeItem() does nothing if the key doesn't exist
        localStorage.removeItem("SelfInitiatedCallCard");
        if (App.currentCC.id && selfInitiatedCallCardId === App.currentCC.id.toString()) {
            return true;
        } else {
            return false;
        }
    }

    //helper function of updateMdtCallCardOfficerTimeFromButton
    private getBackupUnitIdToModifyTime(officerId: number): number {
        let lastBackupUnitId: number = -1; //-1 means not found
        if (officerId == App.currentCC.primaryOfficer) {
            if (!hasValue(App.currentCC.primaryCleared)) {
                return 0;
            }
            lastBackupUnitId = 0 //set to 0 if primary
        }
        if (hasValue(App.currentCC.backupUnits)) {
            for (const backupUnit of App.currentCC.backupUnits) {
                if (officerId == backupUnit.officer) {
                    if (!hasValue(backupUnit.cleared)) {
                        return backupUnit.id;
                    }
                    lastBackupUnitId = backupUnit.id;
                }
            }
        }

        return lastBackupUnitId;
    }

    private updateMdtCallCardOfficerTimeFromButton(updatedTime: Date, updateTimeType: string) {
        //note: the following code should be uncommented if we do not refresh after the officer time update
        //const officerId: number = getCurrentUserId();
        //const backupUnitId: number = this.getBackupUnitIdToModifyTime(officerId);
        //if (backupUnitId === -1) { //officer not found on call card
        //    //do nothing
        //} else if (backupUnitId === 0) { //officer is primary officer
        //    if (updateTimeType === "dispatched") {
        //        App.currentCC.primaryDispatched = updatedTime;
        //        App.currentCC.whenPrimaryDispatchedChanged = getCurrentTime();
        //    } else if (updateTimeType === "enroute") {
        //        App.currentCC.primaryEnroute = updatedTime;
        //        App.currentCC.whenPrimaryEnrouteChanged = getCurrentTime();
        //    } else if (updateTimeType === "onScene") {
        //        App.currentCC.primaryOnScene = updatedTime;
        //        App.currentCC.whenPrimaryOnSceneChanged = getCurrentTime();
        //    } else if (updateTimeType === "cleared") {
        //        App.currentCC.primaryCleared = updatedTime;
        //        App.currentCC.whenPrimaryClearedChanged = getCurrentTime();
        //    }
        //} else { //officer is a backup unit with row id of backupUnitId
        //    let backupUnit = _.find(App.currentCC.backupUnits, (e) => { return hasValue(e.id) && e.id.toString() === backupUnitId.toString() });
        //    if (hasValue(backupUnit)) {
        //        if (updateTimeType === "dispatched") {
        //            backupUnit.dispatched = updatedTime;
        //            backupUnit.whenDispatchedChanged = getCurrentTime();
        //        } else if (updateTimeType === "enroute") {
        //            backupUnit.enroute = updatedTime;
        //            backupUnit.whenEnrouteChanged = getCurrentTime();
        //        } else if (updateTimeType === "onScene") {
        //            backupUnit.onScene = updatedTime;
        //            backupUnit.whenOnSceneChanged = getCurrentTime();
        //        } else if (updateTimeType === "cleared") {
        //            backupUnit.cleared = updatedTime;
        //            backupUnit.whenClearedChanged = getCurrentTime();
        //        }
        //    } else {
        //        //error
        //    }
        //}
    }

    private isCurrentUserEnrouteOnSceneOrCleared(officerTimeType: string): boolean {
        const officerId: number = getCurrentUserId();
        const backupUnitId: number = this.getBackupUnitIdToModifyTime(officerId);
        if (backupUnitId === -1) { //officer not found on call card
            return false
        } else if (backupUnitId === 0) { //officer is primary officer
            if (officerTimeType === "enroute") {
                return App.currentCC.primaryEnroute !== null;
            } else if (officerTimeType === "onScene") {
                return App.currentCC.primaryOnScene !== null;
            } else if (officerTimeType === "cleared") {
                return App.currentCC.primaryCleared !== null;
            }
        } else { //officer is a backup unit with row id of backupUnitId
            let backupUnit = App.currentCC.backupUnits.find((e) => { return hasValue(e.id) && e.id.toString() === backupUnitId.toString() });
            if (hasValue(backupUnit)) {
                if (officerTimeType === "enroute") {
                    return backupUnit.enroute !== null;
                } else if (officerTimeType === "onScene") {
                    return backupUnit.onScene !== null;
                } else if (officerTimeType === "cleared") {
                    return backupUnit.cleared !== null;
                }
            } else {
                //error
            }
        }
        return false;
    }

    private isCurrentUserEnroute(): boolean {
        return this.isCurrentUserEnrouteOnSceneOrCleared('enroute');
    }
    private isCurrentUserOnScene(): boolean {
        return this.isCurrentUserEnrouteOnSceneOrCleared('onScene');
    }
    private isCurrentUserCleared(): boolean {
        return this.isCurrentUserEnrouteOnSceneOrCleared('cleared');
    }
}

export function addRealtimeCallComment(message: any) {
    if (hasValue(message) && hasValue(App.currentCC) && message.callCardId === App.currentCC.id) {
        const newCallComment = new CallComment(message);
        if (!isCallCommentDuplicate(newCallComment)) {
            addCallCommentHelper(newCallComment);
            // Notify React component if it exists
            if ((window as any).CallCardCommentsComponent) {
                (window as any).CallCardCommentsComponent.handleRealtimeAdd(message);
            }
        }
    }
}

export function updateRealtimeCallComment(message: any) {
    if (hasValue(message) && hasValue(App.currentCC) && message.callCardId === App.currentCC.id) {
        updateCallCommentEntry(message.id, message.entry);
        // Notify React component if it exists
        if ((window as any).CallCardCommentsComponent) {
            (window as any).CallCardCommentsComponent.handleRealtimeUpdate(message);
        }
    }
}

//Start from the back of the list (most recent), and move toward oldest comment.
//If the existing comment is older than the new comment, the new message is not a duplicate
// since the existing comments are ordered from oldest to newest.
//If the existing comment is a duplicate, return true.
//If the existing comment is newer than the new message, the messages are out of order,
// possibly resulting from multiple (different) duplicates getting added.
export function isCallCommentDuplicate(callComment: CallComment): boolean {
    let callComments: Array<CallComment> = App.currentCCCntr.callComments;
    for (let i: number = callComments.length - 1; i >= 0; i--) {
        let existingComment: CallComment = callComments[i];
        if (existingComment.dateCreated.getDate() < callComment.dateCreated.getDate()) {
            return false;
        } else if (existingComment.dateCreated.getDate() === callComment.dateCreated.getDate() && existingComment.id === callComment.id) {
            return true;
        }
    }
    return false;
}

export function addCallCommentHelper(callComment: CallComment) {
    let callComments: Array<CallComment> = App.currentCCCntr.callComments;
    let isAdded: boolean = false;
    let newCallComment: CallComment = new CallComment({ id: callComment.id, entry: callComment.entry, dateCreated: callComment.dateCreated, creatorName: callComment.creatorName });
    for (let i: number = callComments.length - 1; i >= 0; i--) {
        if (App.currentCCCntr.callCommentCompare(newCallComment, callComments[i]) > 0) {
            App.currentCCCntr.callComments.splice(i + 1, 0, newCallComment);
            isAdded = true;
            break;
        }
    }
    if (!isAdded) {
        App.currentCCCntr.callComments.push(newCallComment);
    }
}

export function updateCallCommentEntry(callCommentId: number, updatedEntry: string) {
    let callComments: Array<CallComment> = App.currentCCCntr.callComments;
    let callCommentToUpdate: CallComment = getObjectInArrayByProperty(callComments, 'id', callCommentId);
    callCommentToUpdate.entry = updatedEntry;
}

export function notifyOfficerStayingOnCallCard() {
    if (hasValue(App.sndCCUpdate)) {
        App.sndCCUpdate.play().catch(() => {});
    }

    // Blink the My Call button (SelfInitiate) using toolbar
    if (App.toolbarMDT?.blinkItem) {
        App.toolbarMDT.blinkItem('SelfInitiate', true);
        const timeoutTimes = [500, 1000, 1500, 2000, 2500];
        for (let timeoutTime of timeoutTimes) {
            setTimeout(() => {
                if (App.toolbarMDT?.blinkItem) {
                    App.toolbarMDT.blinkItem('SelfInitiate', timeoutTime % 1000 === 0);
                }
            }, timeoutTime);
        }
    }
}

//This is a helper function to realtimeUpdateCallCard() which calls updateCallCardChanges() once the call card screen is loaded
// if the call card screen was still loading when realtimeUpdateCallCard() was called.
export function checkRealtimeUpdateCallCardScreenLoaded() {
    if (isCallCardRealtimeEnabled()) {
        clearTimeout(realtimeUpdateCallCardScreenLoadedTimeout);
        realtimeUpdateCallCardScreenLoadedTimeout = null;
        api.getCallCardById(App.currentCCSubscribedId, false, result => {
            updateCallCardChanges(new CallCard(result, ModuleType.cad, false), App.currentCCOriginal, App.currentCC);
        });
    } else {
        realtimeUpdateCallCardScreenLoadedTimeout = setTimeout(checkRealtimeUpdateCallCardScreenLoaded, 500);
    }
}

//A request to a realtime update for a call card was received, so sync the current call card with the latest from the back-end.
export function realtimeUpdateCallCard(callCardId: any) {
    //If we are viewing a call card, which may or may not have loaded yet.
    if (App.currentCCSubscribedId !== null && callCardId.toString() === App.currentCCSubscribedId.toString()) {

        if (!App.currentCC || !App.currentCCCntr || !isCallCardRealtimeEnabled()) {
            // User has navigated away or screen isn't ready - don't update UI
            return;
        }

        //If the call card screen is loaded, and we can update the UI elements, get latest call card info.
        if (isCallCardRealtimeEnabled()) {
            api.getCallCardById(App.currentCCSubscribedId, false, result => {

                if (!App.currentCC || !App.currentCCCntr || !isCallCardRealtimeEnabled()) {
                    return;
                }

                //Update the current call card based to sync with the latest call card information.
                updateCallCardChanges(new CallCard(result, ModuleType.cad, false), App.currentCCOriginal, App.currentCC);
            });
        } else {
            //If the call card screen isn't loaded yet, wait for the call card screen to finish loading.
            if (realtimeUpdateCallCardScreenLoadedTimeout === null) {
                realtimeUpdateCallCardScreenLoadedTimeout = setTimeout(checkRealtimeUpdateCallCardScreenLoaded, 500);
            }
        }
    } else {
        // InProgress + map updates: React's updateInProgressScreenFromEvent has its own guard
        updateInProgressScreenFromEvent(callCardId);
        if (isMapScreenLoaded()) { //if we are viewing the map screen
            updateMapFromEvent();
        }
    }
}

export function getOfficerListFromCallCard(callCard: CallCard) {
    const officers = [];
    const primaryOfficer = new Officer(
        null,
        callCard.primaryOfficer,
        callCard.primaryOfficerName,
        callCard.primaryDispatched,
        callCard.whenPrimaryDispatchedChanged,
        callCard.primaryEnroute,
        callCard.whenPrimaryEnrouteChanged,
        callCard.primaryOnScene,
        callCard.whenPrimaryOnSceneChanged,
        callCard.primaryCleared,
        callCard.whenPrimaryClearedChanged,
        true,
        callCard.primaryStartingMileage,
        callCard.primaryEndingMileage,
        null,  // eventId
        null,  // callCardId
        false  // isQueued
    );

    if (primaryOfficer.officer !== null)
        officers.push(primaryOfficer);

    for (let officer of callCard.backupUnits) {
        officers.push(
            new Officer(
                officer.id,
                officer.officer,
                officer.officerName,
                officer.dispatched,
                officer.whenDispatchedChanged,
                officer.enroute,
                officer.whenEnrouteChanged,
                officer.onScene,
                officer.whenOnSceneChanged,
                officer.cleared,
                officer.whenClearedChanged,
                officer.isPrimary,
                officer.startingMileage,
                officer.endingMileage,
                officer.eventId || null,     // Add eventId
                officer.callCardId || null,  // Add callCardId  
                officer.isQueued || false    // Add isQueued
            )
        );
    }

    for (let officer of callCard.queuedUnits) {
        officers.push(
            new Officer(
                officer.id,
                officer.officer,
                officer.officerName,
                officer.dispatched,
                officer.whenDispatchedChanged,
                officer.enroute,
                officer.whenEnrouteChanged,
                officer.onScene,
                officer.whenOnSceneChanged,
                officer.cleared,
                officer.whenClearedChanged,
                officer.isPrimary,
                officer.startingMileage,
                officer.endingMileage,
                officer.eventId || null,     // Add eventId - CRITICAL FOR BUSY STATE
                officer.callCardId || null,  // Add callCardId
                officer.isQueued || true     // Add isQueued - CRITICAL FOR BUSY STATE
            )
        );
    }

    return officers;
}

export function updateDatePropertyChanges(latestObj: any, originalObj: any, currentObj: any, propName: string) {
    const propVal: any = latestObj[propName];
    const originalPropVal: any = originalObj[propName]
    const propValTime: number = ((propVal === null) ? (null) : (propVal.getTime()));
    const originalTime: number = ((originalPropVal === null) ? (null) : (originalPropVal.getTime()));
    if (propValTime !== originalTime) {
        if (propValTime === null) {
            originalObj[propName] = null;
            currentObj[propName] = null;

            return true;
        } else {
            originalObj[propName] = new Date(propVal);
            currentObj[propName] = new Date(propVal);

            return true;
        }
    }

    return false;
}

export function updatePrimitivePropertyChanges(latestObj: any, originalObj: any, currentObj: any, propName: string) {
    const propVal: any = latestObj[propName];
    if (propVal !== originalObj[propName]) {
        originalObj[propName] = propVal;
        currentObj[propName] = propVal;

        return true;
    }

    return false;
}

//latestCallCard is the latest call card information (e.g. due to a realtime update),
// originalCallCard is the call card information when the user initially loaded the call card and also kept in sync with realtime updates, and
// currentCallCard is the call card information of the current call card which was initially loaded and kept in sync with realtime updates
//   and may have been modified by the user before saving.
// Note that "My Call"/"Self Initiate" on MDT menu is updated from realtime messages "officerOnCallCard" and "officerRemovedFromCallCard", not here.
export function updateCallCardChanges(latestCallCard: CallCard, originalCallCard: CallCard, currentCallCard: CallCard) {
    let propertiesToSkip = { 'natureOfCall': true, 'callDateTime': true, 'callDisposition': true, 'ccStatus': true, 'backupUnits': true, 'queuedUnits': true, 'people': true, 'vehicles': true, 'client': true };
    let areCallCardOfficersUpdated: boolean = false;

    const isCallLocFormattedAddressChanged: boolean = latestCallCard.callLocFormattedAddress !== originalCallCard.callLocFormattedAddress;

    for (let propName in latestCallCard) {
        if (propertiesToSkip[propName]) {
            continue;
        }
        let propVal: any = latestCallCard[propName];
        if (isDateObject(propVal)) {
            if (updateDatePropertyChanges(latestCallCard, originalCallCard, currentCallCard, propName)) {
                if (CallCard.isPrimaryOfficerField(propName)) {
                    areCallCardOfficersUpdated = true;
                }
            }
        } else {
            if (updatePrimitivePropertyChanges(latestCallCard, originalCallCard, currentCallCard, propName)) {
                if (CallCard.isPrimaryOfficerField(propName)) {
                    areCallCardOfficersUpdated = true;
                }
            }
        }
    }

    if (!arraysEqual(latestCallCard.natureOfCall, originalCallCard.natureOfCall)) {
        originalCallCard.natureOfCall = latestCallCard.natureOfCall.slice();
        currentCallCard.natureOfCall = latestCallCard.natureOfCall.slice();
    }

    if (updateDatePropertyChanges(latestCallCard, originalCallCard, currentCallCard, "callDateTime")) {
        // DateTime picker will update automatically via state
    }

    if (CallCardClientGroup.updateCallCardClientGroupChanges(latestCallCard, originalCallCard, currentCallCard)) {
        // React component will update automatically via state on currentCallCard.client
        // Update site options if client has allSites
        if (hasValue(latestCallCard.client) && hasValue(latestCallCard.client.id) && App.callCardController) {
            if (hasValue(latestCallCard.client.allSites)) {
                App.callCardController!.siteOptions = latestCallCard.client.allSites;
            }
            // Update client link
            const clientItem = App.callCardController!.clientOptions.find((c: any) => c.id === latestCallCard.client.id);
            if (clientItem) {
                App.callCardController!.fnUpdateCallCardClientLink(clientItem.id, clientItem.name, clientItem.companyId);
            }
        }
    }

    if (updatePrimitivePropertyChanges(latestCallCard, originalCallCard, currentCallCard, "callDisposition")) {
        // React component will update automatically via state
    }

    originalCallCard.ccStatus = latestCallCard.ccStatus;
    currentCallCard.ccStatus = latestCallCard.ccStatus;
    if (App.callCardController) {
        App.callCardController.callCardNotClosed = (latestCallCard.ccStatus !== CallCardStatus.CASE_CLOSED);
    }

    // Update officer arrays
    if (updateCloneableObjectArrayChanges(latestCallCard.backupUnits, originalCallCard.backupUnits, currentCallCard.backupUnits)) {
        areCallCardOfficersUpdated = true;
    }
    if (updateCloneableObjectArrayChanges(latestCallCard.queuedUnits, originalCallCard.queuedUnits, currentCallCard.queuedUnits)) {
        areCallCardOfficersUpdated = true;
    }

    // Update grid component if officers changed
    if (areCallCardOfficersUpdated && App.callCardController) {
        const updatedOfficers = getOfficerListFromCallCard(latestCallCard);
        App.callCardController.officers = convertOfficersForGrid(updatedOfficers);
    }

    if (updateCloneableObjectArrayChanges(latestCallCard.people, originalCallCard.people, currentCallCard.people)) {
        updatePeopleFromCallCard(latestCallCard.people);
    }

    if (updateCloneableObjectArrayChanges(latestCallCard.vehicles, originalCallCard.vehicles, currentCallCard.vehicles)) {
        updateVehiclesFromCallCard(latestCallCard.vehicles);
    }

    // Update attachments
    if (!arraysEqual(
        latestCallCard.attachmentList?.map((a: any) => a.id),
        originalCallCard.attachmentList?.map((a: any) => a.id)
    )) {
        originalCallCard.attachmentList = latestCallCard.attachmentList.slice();
        currentCallCard.attachmentList = latestCallCard.attachmentList.slice();
        if (App.callCardController && App.callCardController.attachments !== undefined) {
            App.callCardController.attachments = latestCallCard.attachmentList.slice();
        }
    }

    if (App.callCardController) {
        if (App.callCardController.module === ModuleType.mdt) {
            updateMDTEditModeAllowed();
        }

        // Trigger React re-render so mutated CC properties (natureOfCall, callDateTime, etc.) are picked up
        if (App.callCardController.forceUpdate) {
            App.callCardController.forceUpdate();
        }
    }
}

export function isCallCardControllerReady(): boolean {
    return hasValue(App.callCardController) &&
        Array.isArray(App.callCardController!.people) &&
        Array.isArray(App.callCardController!.vehicles);
}

/**
 * Update people array from latest CallCard data
 * Always generates new UUIDs since they're frontend-only
 */
export function updatePeopleFromCallCard(latestPeople: Array<CCPerson>): void {
    if (!isCallCardControllerReady()) {
        console.warn('CallCard controller not ready for people update');
        return;
    }

    // Simply convert all people to grid format with new UUIDs
    App.callCardController!.people = latestPeople.map(person => ({
        uuid: getInsecureUUID(), // Always generate new UUID
        id: person.id,           // Backend database ID
        firstName: person.firstName,
        lastName: person.lastName,
        dob: person.dob,
        license: person.license,
        notes: person.notes,
        npsdPerson: person.npsdPerson
    }));
}

/**
 * Update vehicles array from latest CallCard data
 * Always generates new UUIDs since they're frontend-only
 */
export function updateVehiclesFromCallCard(latestVehicles: Array<CCVehicle>): void {
    if (!isCallCardControllerReady()) {
        console.warn('CallCard controller not ready for vehicles update');
        return;
    }

    // Simply convert all vehicles to grid format with new UUIDs
    App.callCardController!.vehicles = latestVehicles.map(vehicle => ({
        uuid: getInsecureUUID(), // Always generate new UUID
        id: vehicle.id,          // Backend database ID
        make: vehicle.make,
        model: vehicle.model,
        color: vehicle.color,
        year: vehicle.year,
        plateNumber: vehicle.plateNumber,
        plateState: vehicle.plateState,
        vehicleType: vehicle.vehicleType,
        notes: vehicle.notes,
        npsdVehicle: vehicle.npsdVehicle
    }));
}

export function updateCloneableObjectArrayChanges(latestObjectArr: Array<ICloneable>, originalObjectArr: Array<ICloneable>, currentObjectArr: Array<ICloneable>) {
    let isModified: boolean = false;

    if (latestObjectArr.length != originalObjectArr.length) {
        originalObjectArr.splice(0, originalObjectArr.length); //clear the array
        currentObjectArr.splice(0, currentObjectArr.length); //clear the array
        for (let latestObj of latestObjectArr) {
            originalObjectArr.push(latestObj.clone());
            currentObjectArr.push(latestObj.clone());
        }

        isModified = true;
    }
    for (let i = 0; i < latestObjectArr.length; i++) {
        const latestObject = latestObjectArr[i];
        const originalObject = originalObjectArr[i];
        const currentOfficer = currentObjectArr[i];

        for (let propName in latestObject) {
            const propVal: any = latestObject[propName];
            if (isDateObject(propVal)) {
                if (updateDatePropertyChanges(latestObject, originalObject, currentOfficer, propName)) {
                    isModified = true;
                }
            } else {
                if (updatePrimitivePropertyChanges(latestObject, originalObject, currentOfficer, propName)) {
                    isModified = true;
                }
            }
        }
    }
    return isModified;
}

// Form submit prevention is now handled by @submit.prevent in CallCard.html

// Map links now use onclick attributes - see callLocationMapLink computed property

document.addEventListener("click", e => {
    const target = (e.target as HTMLElement).closest('#lnkCallCardAddCustomLocation') as HTMLElement;
    if (!target) return;
    const coordinates = target.dataset.coords;
    App.callCardController!.openAddCustomLocationDialog(coordinates);
});

export class Company {
    name: string;
    email: string;
    address1: string;
    address2: string;
    city: string;
    state: string;
    zip: string;
    phoneNumber: string;
    authorizorName: string;

    constructor(result: any) {
        if (result !== undefined && result !== null) {
            for (let k in result) {
                if (this[k] !== undefined) {
                    this[k] = result[k];
                }
            }
        }
    }
}

export class Client {
    constructor(result: any) {
        if (result !== undefined && result !== null) {
            for (let k in result) {
                if (this[k] !== undefined) {
                    this[k] = result[k];
                }
            }
        }
    }

    Id: number;
    name: string;// client name
    website: string;// website url
    notes: string;// notes
    locName: string;// location name
    locAddress: string;// location address line 1
    locAddress2: string;// location address line 2
    locCity: string;// location city
    locState: string;// location state
    locZip: string;// location zip
    locCountry: string;// location country
}

// Tabs now handled by React selectTab method

export function clearCallCardClockRefresh(): void {
    if (callCardClockRefreshInterval !== null) {
        clearInterval(callCardClockRefreshInterval); // Will clear the timer.
        callCardClockRefreshInterval = null;
    }
}

export function resetCallCardClockRefresh(): void {
    clearCallCardClockRefresh();
    callCardClockRefreshInterval = setInterval(() => {
        updateCallCardClock();
    }, 1000); //updates call card clock once a second
}

export function updateCallCardClock(): void {
    if (App.callCardController) {
        App.callCardController!.clockTime = new Date().toLocaleTimeString();
    }
}

// Client modal now handled by React - see openClientModal method
// Map modal now handled by React - see openMapModal method
// SOP modal now handled by React - see openSopModal method
// Connections search modal now handled by React - see openConnectionsSearchModal method

export function getCCVehicleTypeFromVehicleType(vehicleType: object): object {
    if (typeof vehicleType === 'number') {
        return deepCopyProperties(getObjectInArrayByProperty(Codes.getVehicleTypes(), 'code', vehicleType));
    } else {
        return vehicleType;
    }
}

export function setupCallbackForDispositionNotesOnCurrentCallLoaded(dispositionNotes: string): void {
    (window as any)._currentCallCardLoadedCallback = function () {
        App.currentCC.dispositionNotes = dispositionNotes;
    }
}

export function convertOfficersForGrid(officers: Array<Officer>) {
    if (!officers) {
        return []
    }
    return officers.map(officer => {
        // Determine if officer is busy on another call
        const isBusy = officer.isQueued || (officer.eventId !== null && officer.eventId !== App.currentCC.eventId);

        return {
            uuid: getInsecureUUID(),
            id: officer.id,
            officerId: officer.officer,
            name: officer.officerName,
            isPrimary: officer.isPrimary,
            dispatched: officer.dispatched,
            enroute: officer.enroute,
            onScene: officer.onScene,
            cleared: officer.cleared,
            startingMileage: officer.startingMileage,
            endingMileage: officer.endingMileage,
            // Map existing fields for busy state
            isQueued: officer.isQueued || false,
            eventId: officer.eventId || null,
            callCardId: officer.callCardId || null,
            // Derived fields for React component
            isBusy: isBusy,
            currentEventId: officer.eventId,
            busyReason: 'BUSY'
        }
    })
}

// Initialize people and vehicles data
export function convertPeopleForGrid(people: Array<CCPerson>) {
    return people.map(person => ({
        uuid: getInsecureUUID(),
        id: person.id,
        firstName: person.firstName,
        lastName: person.lastName,
        dob: person.dob,
        license: person.license,
        notes: person.notes,
        npsdPerson: person.npsdPerson
    }));
}

export function convertVehiclesForGrid(vehicles: Array<CCVehicle>) {
    return vehicles.map(vehicle => ({
        uuid: getInsecureUUID(),
        id: vehicle.id,
        make: vehicle.make,
        model: vehicle.model,
        color: vehicle.color,
        year: vehicle.year,
        plateNumber: vehicle.plateNumber,
        plateState: vehicle.plateState,
        vehicleType: vehicle.vehicleType,
        notes: vehicle.notes,
        npsdVehicle: vehicle.npsdVehicle
    }));
}

// Functions for create, link, unlink vue component for person and vehicle grid components.

export function callCardAddNpsdPerson(uuid: string, personData: any) {
    if (!hasValue(personData.firstName) || !hasValue(personData.lastName)) {
        App.showPopupNotification("Person requires first and last name.", "error");
        return false;
    }

    let person = new Person({
        lastName: personData.lastName,
        firstName: personData.firstName,
        dob: personData.dob,
        driversLicenseNum: personData.license,
        notes: personData.notes,
    });

    api.saveNPSDItem(person, "person", result => {
        const people = App.callCardController!.people;
        const personIndex = people.findIndex(p => p.uuid === uuid);

        if (personIndex !== -1) {
            people[personIndex].npsdPerson = result.id;
            App.callCardController!.people = [...people];
            App.showPopupNotification("Person linked successfully.", "success");
        }
    });

    return false;
}

export function callCardAddNpsdVehicle(uuid: string, vehicleData: any) {
    if (!hasValue(vehicleData.make) || !hasValue(vehicleData.model) || !hasValue(vehicleData.plateNumber)) {
        App.showPopupNotification("Vehicle requires make, model, and plate number.", "error");
        return false;
    }

    let plateState: string = vehicleData.plateState;

    if (hasValue(plateState) && plateState !== "") {
        const plateStateInList = Codes.getStates().find(o =>
            (o.value.toLowerCase() === plateState.toLowerCase() || o.code.toLowerCase() === plateState.toLowerCase())
        );
        if (plateStateInList !== undefined) {
            plateState = plateStateInList.code;
        } else {
            App.showPopupNotification("Invalid state.", "error");
            return false;
        }
    }

    let vehicleType: number = null;
    if (hasValue(vehicleData.vehicleType)) {
        if (typeof vehicleData.vehicleType === 'object' && hasValue(vehicleData.vehicleType.code)) {
            vehicleType = vehicleData.vehicleType.code;
        } else if (typeof vehicleData.vehicleType === 'number') {
            vehicleType = vehicleData.vehicleType;
        }
    }

    let vehicle = new Vehicle({
        make: vehicleData.make,
        model: vehicleData.model,
        color: vehicleData.color,
        year: vehicleData.year,
        plateNumber: vehicleData.plateNumber,
        plateState: plateState,
        vehicleType: vehicleType,
        notes: vehicleData.notes,
    });

    api.saveNPSDItem(vehicle, "vehicle", result => {
        const vehicles = App.callCardController!.vehicles;
        const vehicleIndex = vehicles.findIndex(v => v.uuid === uuid);

        if (vehicleIndex !== -1) {
            vehicles[vehicleIndex].npsdVehicle = result.id;
            vehicles[vehicleIndex].plateState = plateState;
            App.callCardController!.vehicles = [...vehicles];
            App.showPopupNotification("Vehicle linked successfully.", "success");
        }
    });

    return false;
}

export function updateNPSDItemForCallCard(relType: RelType, dataItem: any, uuid: string) {
    const npsdDataId = dataItem.id;

    if (relType === RelType.person) {
        const people = App.callCardController!.people;
        const personIndex = people.findIndex(p => p.uuid === uuid);

        if (personIndex === -1) {
            App.showPopupNotification("Person not linked to call card.", "error");
        } else {
            const person = people[personIndex];
            person.npsdPerson = npsdDataId;
            person.firstName = dataItem.firstName;
            person.lastName = dataItem.lastName;
            person.dob = dataItem.dob;
            person.license = dataItem.driversLicenseNum;
            person.notes = dataItem.notes;
            App.callCardController!.people = people.slice();
        }
    } else if (relType === RelType.vehicle) {
        const vehicles = App.callCardController!.vehicles;
        const vehicleIndex = vehicles.findIndex(v => v.uuid === uuid);

        if (vehicleIndex === -1) {
            App.showPopupNotification("Vehicle not linked to call card.", "error");
        } else {
            const vehicle = vehicles[vehicleIndex];
            vehicle.npsdVehicle = npsdDataId;
            vehicle.make = dataItem.make;
            vehicle.model = dataItem.model;
            vehicle.color = dataItem.color;
            vehicle.year = dataItem.year;
            vehicle.plateNumber = dataItem.plateNumber;
            vehicle.plateState = dataItem.plateState;
            vehicle.vehicleType = getCCVehicleTypeFromVehicleType(dataItem.vehicleType);
            vehicle.notes = dataItem.notes;
            App.callCardController!.vehicles = vehicles.slice();
        }
    }
}

export function callCardLinkToPerson(uuid: string) {
    callCardLinkToPersonOrVehicle(uuid, RelType.person);
}

export function callCardLinkToVehicle(uuid: string) {
    callCardLinkToPersonOrVehicle(uuid, RelType.vehicle);
}

export function callCardLinkToPersonOrVehicle(uuid: string, relType: RelType) {
    if (!hasValue(uuid) || (relType !== RelType.person && relType !== RelType.vehicle)) {
        api.insertNewJSError(`Parameter Error`, null, null, JSErrorType.UNCAUGHT, null);
        App.showStandardErrorPopupNotification();
        return;
    }

    let gridDataItem: any;

    if (relType === RelType.person) {
        gridDataItem = App.callCardController!.people.find(p => p.uuid === uuid);
    } else if (relType === RelType.vehicle) {
        gridDataItem = App.callCardController!.vehicles.find(v => v.uuid === uuid);
    }

    if (!gridDataItem) {
        App.showPopupNotification("Item not found.", "error");
        return;
    }

    const addNPSDItemToCallCard: Function = (linkId: string, dataItem) => {
        NPSDItemToCallCard(linkId, dataItem, uuid, relType);
    };

    const npsdType = relType === RelType.person ? 'Person' : 'Vehicle';
    App.callCardController!.openConnectionsSearchModal(npsdType, addNPSDItemToCallCard, gridDataItem);

    return false;
}

export function NPSDItemToCallCard(linkId: string, dataItem: any, uuid: string, relType: RelType) {
    const npsdDataId = dataItem.id;

    if (linkId === "lnkCallCardLinkPerson") {
        const npsdDataItemExists = App.callCardController!.people.some(p =>
            hasValue(p.npsdPerson) && p.npsdPerson.toString() === npsdDataId.toString()
        );

        if (npsdDataItemExists) {
            App.showPopupNotification("Person already linked to call card.", "error");
        } else {
            const people = App.callCardController!.people;
            const personIndex = people.findIndex(p => p.uuid === uuid);
            if (personIndex !== -1) {
                const person = people[personIndex];
                person.npsdPerson = npsdDataId;
                person.firstName = dataItem.firstName;
                person.lastName = dataItem.lastName;
                person.dob = dataItem.dob;
                person.license = dataItem.driversLicenseNum;
                person.notes = dataItem.notes;
                // Trigger React re-render by setting a new array reference
                App.callCardController!.people = people.slice();
            }
        }
    } else if (linkId === "lnkCallCardLinkVehicle") {
        const npsdDataItemExists = App.callCardController!.vehicles.some(v =>
            hasValue(v.npsdVehicle) && v.npsdVehicle.toString() === npsdDataId.toString()
        );

        if (npsdDataItemExists) {
            App.showPopupNotification("Vehicle already linked to call card.", "error");
        } else {
            const vehicles = App.callCardController!.vehicles;
            const vehicleIndex = vehicles.findIndex(v => v.uuid === uuid);
            if (vehicleIndex !== -1) {
                const vehicle = vehicles[vehicleIndex];
                vehicle.npsdVehicle = npsdDataId;
                vehicle.make = dataItem.make;
                vehicle.model = dataItem.model;
                vehicle.color = dataItem.color;
                vehicle.year = dataItem.year;
                vehicle.plateNumber = dataItem.plateNumber;
                vehicle.plateState = dataItem.plateState;
                vehicle.vehicleType = getCCVehicleTypeFromVehicleType(dataItem.vehicleType);
                vehicle.notes = dataItem.notes;
                // Trigger React re-render by setting a new array reference
                App.callCardController!.vehicles = vehicles.slice();
            }
        }
    }
}

// ============================================================================
// Notification dialogs — extracted to ./notification-dialogs.ts
// ============================================================================
export {
    CancelPanicDialog, cancelPanicDialog, _cancelPanicContainer, _cancelPanicIsOpen,
    OfficerAssignedDialogInfo, previousOfficerAssignedDialogInfo,
    showRecentOfficerAssignedDialogOnPageLoaded,
    isShowingRecentOfficerAssignedDialogOnPageLoaded,
    setShowingRecentOfficerAssignedDialogOnPageLoaded,
    _officerAssignedContainer, _officerAssignedCallCardId, _officerAssignedState,
    _renderOfficerAssignedDialog, showOfficerAssignedDialog,
    showOfficerAssignedDialogAndNotify,
    showRecentOfficerAssignedDialogIfNotVisibleWithoutSound,
    showPageMDTCallCard, btnOfficerAssignedCallCardDialogViewCallClicked,
    PanicDialogInfo, _panicDialogContainer, _panicCallCardId, _panicDialogState,
    _renderPanicDialog, showPanicDialog, stopPanicSounds,
    playPanicSound2Interval, showPanicDialogAndNotify,
    showPageCADCallCard, btnPanicCallCardDialogViewCallClicked,
    CaseReportSubmittedDialogInfo,
    _caseReportSubmittedHandle, _caseReportSubmittedCaseReportId,
    _caseReportSubmittedIsOpen, showCaseReportSubmittedDialog,
    _renderCaseReportSubmittedDialog, _closeCaseReportSubmittedReact,
    btnCaseReportSubmittedForSupervisorReviewDialogViewCaseReportClicked,
} from './notification-dialogs';

// Ensure notification-dialogs module is imported (it self-registers window globals)
import './notification-dialogs';

// (Dialog code moved to ./notification-dialogs.ts)


// ============================================================================
// Window registrations — make entity classes available globally
// ============================================================================

// Core types (AccessAuthorities window reg moved to @/models/access-authorities.ts)
(window as any).EntityBase = EntityBase;

// Call Card types
(window as any).CallCard = CallCard;
(window as any).CallCardController = CallCardController;
(window as any).CallCardClientGroup = CallCardClientGroup;
(window as any).CallCardClientGroupSite = CallCardClientGroupSite;
(window as any).CallComment = CallComment;
(window as any).CallCardInProgressStatus = CallCardInProgressStatus;
(window as any).MDTInProgressStatus = MDTInProgressStatus;
(window as any).CallCardStatus = CallCardStatus;
(window as any).CCAction = CCAction;

// Entity types
(window as any).Officer = Officer;
(window as any).CCPerson = CCPerson;
(window as any).CCVehicle = CCVehicle;
(window as any).Person = Person;
(window as any).Vehicle = Vehicle;
(window as any).Business = Business;
(window as any).ClientGroup = ClientGroup;
(window as any).Company = Company;
(window as any).Client = Client;
(window as any).NewUser = NewUser;
(window as any).CompanyProfile = CompanyProfile;
(window as any).CompanyVehicle = CompanyVehicle;
(window as any).CompanyLink = CompanyLink;
(window as any).Citation = Citation;
(window as any).PhoneNumber = PhoneNumber;
(window as any).Email = Email;
(window as any).ServerErrors = ServerErrors;
(window as any).ServerError = ServerError;

// Supporting types
(window as any).Attachment = Attachment;
(window as any).AttachmentInfo = AttachmentInfo;
(window as any).AttachmentWithGuid = AttachmentWithGuid;
(window as any).AttachmentInfoWithGuid = AttachmentInfoWithGuid;
(window as any).BackUpUnit = BackUpUnit;
(window as any).RespondingAgency = RespondingAgency;
(window as any).Offender = Offender;
(window as any).Accident = Accident;
(window as any).accidentPerson = accidentPerson;
(window as any).Property = Property;
(window as any).EstimatedValue = EstimatedValue;
(window as any).MedicalReport = MedicalReport;
(window as any).ReportClientGroup = ReportClientGroup;
(window as any).Statement = Statement;
(window as any).DigitalEvidence = DigitalEvidence;
(window as any).NameValue = NameValue;
(window as any).NPSDReport = NPSDReport;
(window as any).JSErrorType = JSErrorType;
(window as any).KSTPositionError = KSTPositionError;
(window as any).GeocodedLocation = GeocodedLocation;

// NPSD Relationships
(window as any).connections = connections;
(window as any).UpdateConnections = UpdateConnections;
(window as any).npsdPersonConnection = npsdPersonConnection;
(window as any).npsdVehicleConnection = npsdVehicleConnection;
(window as any).npsdBusinessConnection = npsdBusinessConnection;
(window as any).npsdCGConnection = npsdCGConnection;
(window as any).RelType = RelType;
(window as any).RelTypePlural = RelTypePlural;
(window as any).Warning = Warning;
(window as any).GateCode = GateCode;

// Tour types
(window as any).Tour = Tour;
(window as any).TourAvailability = TourAvailability;
(window as any).TourStop = TourStop;
(window as any).TourClient = TourClient;
(window as any).TourStopCheck = TourStopCheck;
(window as any).TourStopTask = TourStopTask;
(window as any).SensitiveTask = SensitiveTask;
(window as any).GuardTour = GuardTour;
(window as any).GuardTourStop = GuardTourStop;
(window as any).GuardTourStopTask = GuardTourStopTask;
(window as any).GuardTourCompletion = GuardTourCompletion;
(window as any).TourStopChecklistItem = TourStopChecklistItem;
(window as any).TourStopIssue = TourStopIssue;
(window as any).UpdateOfficerComments = UpdateOfficerComments;
(window as any).Task = Task;
(window as any).TaskExemption = TourExemption;
(window as any).PendingCaseReport = PendingCaseReport;
(window as any).CallAlert = CallAlert;

// Navigation (window regs kept for backward compat)
(window as any).OrnaNavigationType = OrnaNavigationType;
(window as any).CustomLocationOrCoordinatesType = CustomLocationOrCoordinatesType;

// Data helpers
(window as any).DataObjectLocationFields = DataObjectLocationFields;
(window as any).ClientGroupSite = ClientGroupSite;
(window as any).ClientAutomatedNotification = ClientAutomatedNotification;

// Dialog types — window regs handled by ./notification-dialogs.ts

// Report type
(window as any).mdtReport = typeof mdtReport !== 'undefined' ? mdtReport : undefined;

// Legacy NOC info
(window as any).legacyNocInfo = typeof legacyNocInfo !== 'undefined' ? legacyNocInfo : undefined;

// Call card functions
(window as any).realtimeUpdateCallCard = realtimeUpdateCallCard;
(window as any).addRealtimeCallComment = addRealtimeCallComment;
(window as any).updateRealtimeCallComment = updateRealtimeCallComment;
(window as any).getOfficerListFromCallCard = getOfficerListFromCallCard;
(window as any).convertOfficersForGrid = convertOfficersForGrid;
(window as any).convertPeopleForGrid = convertPeopleForGrid;
(window as any).convertVehiclesForGrid = convertVehiclesForGrid;
(window as any).notifyOfficerStayingOnCallCard = notifyOfficerStayingOnCallCard;
(window as any).clearCallCardClockRefresh = clearCallCardClockRefresh;
(window as any).resetCallCardClockRefresh = resetCallCardClockRefresh;
(window as any).setupCallbackForDispositionNotesOnCurrentCallLoaded = setupCallbackForDispositionNotesOnCurrentCallLoaded;
(window as any).callCardAddNpsdPerson = callCardAddNpsdPerson;
(window as any).callCardAddNpsdVehicle = callCardAddNpsdVehicle;
(window as any).callCardLinkToPerson = callCardLinkToPerson;
(window as any).callCardLinkToVehicle = callCardLinkToVehicle;
(window as any).updateNPSDItemForCallCard = updateNPSDItemForCallCard;
(window as any).getCCVehicleTypeFromVehicleType = getCCVehicleTypeFromVehicleType;

// Panic / officer-assigned dialog functions — window regs handled by ./notification-dialogs.ts

// Open functions
(window as any).Open_Person = typeof Open_Person !== 'undefined' ? Open_Person : undefined;
(window as any).Open_Vehicle = typeof Open_Vehicle !== 'undefined' ? Open_Vehicle : undefined;
(window as any).Open_Business = typeof Open_Business !== 'undefined' ? Open_Business : undefined;
